export default {
  "appName": "فينيكس",
  "welcome": {
    "modalAria": "أهلاً بيك في فينيكس",
    "skip": "تخطّى",
    "next": "التالي",
    "getStarted": "يلا نبدأ",
    "slides": {
      "intro":    { "title": "أهلاً بيك في فينيكس",          "body": "بيت واحد لكل حاجة بتعملها كل يوم — تذكيرات، ألعاب مع شريكك، أخبار، وكل الموديولز اللي كنت بتلف عليها في عشر تطبيقات." },
      "couples":  { "title": "مصمم لكم إنتو الاتنين",        "body": "سؤال يومي، وردل، وكويز ثنائي بيخليكم متابعين بعض على طول — وبتشوفوا إجابات بعض لحظة بلحظة." },
      "tracking": { "title": "سجّل اللي يهمّك",              "body": "وزن، أكل، ميّة، تمارين — كل ده بثواني وبتشوف الترند في الصفحة الرئيسية." },
      "feed":     { "title": "أخبار وسوشيال في مكان واحد",   "body": "Reddit وBluesky وMastodon ويوتيوب وRSS — كل مصادرك في فيد واحد، مترجمين لما تحتاج." },
      "yours":    { "title": "خصّصه على ذوقك",                "body": "الثيم، اللون، الخط، الأصوات، التذكيرات — الإعدادات فيها كل المفاتيح. الديفولت كويس بس ذوقك أحسن." }
    }
  },
  "tour": {
    "stepCounter": "الخطوة {{current}} من {{total}}",
    "skip": "تخطّى الجولة",
    "skipAria": "تخطّى الجولة",
    "back": "للوراء",
    "next": "التالي",
    "finish": "تم",
    "steps": {
      "greeting":  { "title": "بيتك اليومي",            "body": "كل مرة بتفتح التطبيق بتبدأ هنا — اللوحة الرئيسية. التاريخ والسلسلة المشتركة فوق." },
      "checkins":  { "title": "تذكيرات اليوم",           "body": "اضغط أي خانة عشان تسجّلها — بتتحول لخضرا أول ما تخلّص ليومك." },
      "couples":   { "title": "إنت وشريكك",              "body": "سؤال اليوم، وردل، والكويز — التلاتة بيتحدثوا لحظياً حسب اللي عملته إنت وشريكك." },
      "headline":  { "title": "أهم خبر",                  "body": "أهم خبر من مصادرك، مترجم لما يلزم. اضغط تفتح المقالة كاملة." },
      "modules":   { "title": "باقي التطبيق",             "body": "التقارير، الفلوس، المراحل، الصحة — الموديولز اللي مش بتفتحها كل يوم هنا، على بُعد ضغطتين." },
      "bottomBar": { "title": "تابات الرئيسية",           "body": "الرئيسية، الوجبات، التمارين، السوشيال، الوزن، البروفايل — ستة وجهات يومية. اضغط على التاب اللي إنت عليه تاني عشان ترجع لفوق." },
      "profile":   { "title": "البروفايل",                "body": "اضغط صورتك تعدّل بياناتك أو افتح القائمة الجانبية للإعدادات والتقارير." }
    }
  },
  "features": {
    "gotIt": "تمام",
    "couplesQuiz":     { "title": "كويز للاتنين",         "body": "جولات من ٥ أسئلة — شوف بتعرف شريكك قد إيه." },
    "dailyQuestion":   { "title": "سؤال اليوم",            "body": "سؤال واحد كل يوم للاتنين، والإجابات بتظهر جنب بعض." },
    "wordle":          { "title": "وردل يومي",            "body": "كلمة من ٥ حروف، ٦ محاولات — والسلسلة بتعد الأيام اللي لعبتوا فيها سوا." },
    "profileEdit":     { "title": "البروفايل",             "body": "عدّل اسمك، تاريخ ميلادك، صورتك، وبياناتك في مكان واحد." },
    "reports":         { "title": "التقارير",              "body": "تقارير HTML لأي فترة، بتغطي وزن وأكل وتمارين وتقدم." },
    "financeDues":     { "title": "مواعيد الدفعات",         "body": "الأقساط والفواتير الشهرية — مش هتفوّت أي تاريخ." },
    "phases":          { "title": "مراحل الحياة",          "body": "حدّد فصول حياتك — كل مرحلة بصفحتها." },
    "settings":        { "title": "الإعدادات",             "body": "الثيم، اللون، الخط، الأصوات، الإشعارات — كلها تحت إيدك." },
    "tourReplay":      { "title": "الجولة التعريفية",        "body": "تقدر تعيد الجولة من الإعدادات في أي وقت." },
    "todayDashboard":  { "title": "الرئيسية",              "body": "بيتك الجديد — كل القسم في نظرة واحدة." },
    "tipCard":         { "title": "تلميحات",                "body": "كرت بيتغير وبيوريك حاجات في التطبيق ممكن تكون فاتتك." }
  },
  "debug": {
    "open": "افتح سجل التشخيص",
    "close": "إغلاق",
    "title": "سجل التشخيص",
    "count": "{{count}} سجل · {{errors}} أخطاء",
    "filter": {
      "all": "الكل",
      "warn": "تحذيرات+",
      "error": "أخطاء"
    },
    "copy": "نسخ الكل",
    "copied": "اتنسخ",
    "clear": "مسح",
    "empty": "ما فيش سجلات لسه. استخدم التطبيق وأى log هيظهر هنا."
  },
  "tips": {
    "label": "نصيحة"
  },
  "notifications": {
    "promptTitle": "خلّيك معانا على طول",
    "promptBody": "فعّل الإشعارات وهتوصلك تذكيرات يومية الساعة ٩ الصبح، وكمان إشعار لما شريكك يجاوب على سؤال أو يخلّص جولة كويز.",
    "enable": "فعّل",
    "enabling": "بيتفعّل…",
    "notNow": "مش دلوقتي",
    "enableFailed": "ما اتفعّلش — اتأكد من النت وحاول تاني.",
    "bannerTitle": "الإشعارات مقفولة",
    "bannerBody": "اضغط تفعّلها من الإعدادات",
    "bannerBodyBlocked": "المتصفح حاجبها — افتحها من إعدادات الموقع وبعدين رجّع فعّلها"
  },
  "english": {
    "title": "إنجليزى",
    "subtitle": "تعلّم بذكاء — راجع، اجمع كلمات، وسجّل تقدّمك فى الكورس",
    "welcomeHint": "احفظ الكلمات من أى مقال، راجعها يوميًا، وسجّل تقدّمك فى الكورس.",
    "dashboard": {
      "reviewTitle": "مراجعة",
      "reviewSubtitle": "ذاكر الكلمات المستحقّة اليوم",
      "reviewDue_one": "كلمة واحدة مستحقّة اليوم",
      "reviewDue_two": "كلمتين مستحقّين اليوم",
      "reviewDue_few": "{{count}} كلمات مستحقّة اليوم",
      "reviewDue_many": "{{count}} كلمة مستحقّة اليوم",
      "reviewDue_other": "{{count}} كلمة مستحقّة اليوم",
      "vocabTitle": "الكلمات",
      "vocabSubtitle": "الكلمات اللى حفظتها من القراءة",
      "courseTitle": "الكورس",
      "courseSubtitle": "تابع كورس Udemy / الإنترنت بتاعك",
      "courseSubtitleActive": "{{title}} — {{done}}/{{total}} درس",
      "tutorTitle": "المدرّس",
      "tutorSubtitle": "اتكلم مع مدرّس إنجليزى — تصحيح وتدريب",
      "speakTitle": "النطق",
      "speakSubtitle": "تمرّن على النطق بصوت عالى"
    },
    "speak": {
      "title": "النطق",
      "subtitle_one": "كلمة واحدة للتمرين",
      "subtitle_two": "كلمتين للتمرين",
      "subtitle_few": "{{count}} كلمات للتمرين",
      "subtitle_many": "{{count}} كلمة للتمرين",
      "subtitle_other": "{{count}} كلمة للتمرين",
      "empty": "ما فيش كلمات للتمرين لسه",
      "emptyHint": "احفظ كم كلمة الأول وارجع تتمرّن على نطقها.",
      "unsupported": "التعرّف على الصوت مش متاح على الجهاز ده",
      "unsupportedHint": "التمرين بيستخدم خاصية التعرّف على الصوت فى المتصفح. جرّب تفتح التطبيق على Safari أو Chrome.",
      "targetLabel": "قول الكلمة دى",
      "listen": "اسمعها",
      "record": "اضغط للتسجيل",
      "stop": "إيقاف",
      "tapToRecord": "اضغط على المايك وقول الكلمة",
      "listening": "بنسمع…",
      "heard": "اللى سمعناه",
      "tryAgain": "حاول تانى",
      "next": "التالى",
      "skip": "تخطّى",
      "score": {
        "great": "نطق ممتاز!",
        "ok": "قريّب — حاول تانى",
        "retry": "مش قوى — حاول تانى"
      },
      "errors": {
        "not-allowed": "صلاحية المايك ممنوعة. اسمح بيها فى إعدادات Safari وحاول تانى.",
        "no-speech": "ما سمعناش حاجة — حاول تانى بصوت أعلى شوية.",
        "audio-capture": "ما قدرناش نوصل للمايك. تأكّد من صلاحيات الجهاز.",
        "network": "مشكلة فى الشبكة وقت التعرّف على الصوت.",
        "service-not-allowed": "التعرّف على الصوت مش متاح هنا. جرّب تفتح phoenixtrackers.com فى Safari (مش التطبيق المثبّت) مؤقتاً.",
        "no-start": "المايك ما اشتغلش. التطبيقات المثبّتة أحياناً بتمنع الميزة — جرّب Safari، أو قول لى علشان أركّب تفريغ صوت سحابى."
      }
    },
    "drill": {
      "cta": "اختبرنى على المقال ده",
      "ctaHint": "٣ لـ ٥ أسئلة علشان نتأكد من فهمك.",
      "start": "ابدأ",
      "loading": "بنحضّر الأسئلة…",
      "progress": "سؤال {{current}} من {{total}}",
      "nextQuestion": "التالى",
      "finish": "خلصت",
      "doneTitle": "تمّ الاختبار",
      "score": "{{correct}} / {{total}} صح",
      "fresh": "أسئلة جديدة",
      "retry": "حاول تانى",
      "error": "ما قدرناش نبنى أسئلة من المقال ده."
    },
    "tutor": {
      "title": "المدرّس",
      "subtitle": "اتكلم وأنت بترتاح — تصحيح وتدريب",
      "welcome": "أهلاً! أنا مدرّس الإنجليزى بتاعك. نقدر نعمل سيناريو، نراجع جمل أنت مش متأكد منها، أو نتكلم عادى. اختار واحد علشان نبدأ، أو اكتب أى حاجة.",
      "placeholder": "اكتب بالإنجليزى — هصحّحك بهدوء",
      "send": "إرسال",
      "reset": "إبدأ من جديد",
      "thinking": "المدرّس بيفكر…",
      "suggestions": {
        "roleplay": "Role-play: ordering coffee in a café",
        "checkSentence": "Check this sentence: \"I have went to the gym yesterday\"",
        "practiceTense": "Let's practice past simple — give me 3 prompts",
        "casualChat": "Just casual chat about my day"
      }
    },
    "course": {
      "title": "الكورس",
      "subtitle_one": "كورس واحد بتتابعه",
      "subtitle_two": "كورسين بتتابعهم",
      "subtitle_few": "{{count}} كورسات بتتابعهم",
      "subtitle_many": "{{count}} كورس بتتابعهم",
      "subtitle_other": "{{count}} كورس بتتابعهم",
      "empty": "ما فيش كورس لسه",
      "emptyHint": "ضيف الكورس اللى بتاخده (Udemy أو غيره) وسجّل الدروس وأنت بتخلّصها.",
      "addTitle": "ضيف كورس",
      "titleLabel": "اسم الكورس",
      "titlePlaceholder": "Complete English Course",
      "platformLabel": "المنصّة",
      "urlLabel": "اللينك (اختيارى)",
      "instructorLabel": "المدرّس (اختيارى)",
      "instructorPlaceholder": "اسم المدرّس",
      "totalLabel": "عدد الدروس الكلّى (اختيارى)",
      "save": "احفظ الكورس",
      "cancel": "إلغاء",
      "delete": "حذف",
      "confirmDelete": "اضغط تانى للتأكيد",
      "openSource": "افتح الكورس",
      "progress": "{{done}}/{{total}} درس",
      "showLectures_one": "اعرض درس",
      "showLectures_two": "اعرض درسين",
      "showLectures_few": "اعرض {{count}} دروس",
      "showLectures_many": "اعرض {{count}} درس",
      "showLectures_other": "اعرض {{count}} درس",
      "hideLectures": "إخفاء الدروس",
      "addLecture": "درس",
      "markComplete": "تمّ",
      "markIncomplete": "لسه شغّال عليه",
      "lectureAddTitle": "سجّل درس",
      "lectureTitleLabel": "اسم الدرس",
      "lectureTitlePlaceholder": "Conditional sentences — type 1",
      "lectureNumberLabel": "رقم الدرس",
      "durationLabel": "المدة (دقيقة)",
      "durationPlaceholder": "12",
      "sectionLabel": "القسم (اختيارى)",
      "sectionPlaceholder": "Section 3 — Tenses",
      "notesLabel": "ملاحظات (اختيارى)",
      "notesPlaceholder": "أى حاجة لازم تفتكرها من الدرس…",
      "lectureSave": "احفظ الدرس",
      "lectureEmpty": "ما فيش دروس مسجّلة لسه. اضغط «درس» علشان تضيف."
    },
    "review": {
      "title": "مراجعة",
      "progress": "{{done}} تمّت · {{remaining}} متبقّى",
      "reveal": "اعرض الإجابة",
      "speak": "النطق",
      "empty": "ما فيش حاجة مستحقّة اليوم",
      "emptyHint": "احفظ كم كلمة من أى مقال وارجع هنا.",
      "doneTitle": "أحسنت!",
      "doneBody_one": "راجعت كلمة واحدة اليوم.",
      "doneBody_two": "راجعت كلمتين اليوم.",
      "doneBody_few": "راجعت {{count}} كلمات اليوم.",
      "doneBody_many": "راجعت {{count}} كلمة اليوم.",
      "doneBody_other": "راجعت {{count}} كلمة اليوم.",
      "backToDashboard": "ارجع للإنجليزى",
      "rate": {
        "again": "تانى",
        "hard": "صعبة",
        "good": "كويس",
        "easy": "سهلة"
      }
    },
    "vocab": {
      "title": "الكلمات",
      "subtitle": "{{count}} كلمة محفوظة",
      "addTitle": "إحفظ كلمة",
      "wordLabel": "الكلمة أو العبارة",
      "wordPlaceholder": "مثلاً: resilient",
      "contextLabel": "الجملة (اختيارى)",
      "contextPlaceholder": "الجملة اللى شفت فيها الكلمة",
      "save": "إحفظ",
      "cancel": "إلغاء",
      "delete": "حذف",
      "confirmDelete": "اضغط تانى للتأكيد",
      "speak": "النطق",
      "empty": "ما فيش كلمات محفوظة لسه",
      "emptyHint": "اضغط على أى كلمة فى مقال، أو استخدم + علشان تضيف يدوى.",
      "emptyFiltered": "ما فيش حاجة مطابقة للفلتر الحالى.",
      "searchPlaceholder": "ابحث فى كلماتك…",
      "saveFromArticle": "احفظ للإنجليزى",
      "saveFromSelection": "احفظ",
      "speakSelection": "اسمع",
      "translateSelection": "ترجم",
      "translating": "بنترجم…",
      "closeTranslation": "إغلاق الترجمة",
      "state": {
        "all": "الكل",
        "new": "جديد",
        "learning": "بتعلم",
        "review": "مراجعة",
        "suspended": "موقّف"
      },
      "source": {
        "news": "أخبار",
        "social": "سوشيال",
        "tech": "تقنية",
        "course": "كورس",
        "manual": "يدوى"
      }
    }
  },
  "learning": {
    "title": "التعلم",
    "subtitle": "{{count}} مصدر · {{done}} اتم",
    "addResource": "أضف مصدر",
    "allTopics": "كل المواضيع",
    "open": "افتح",
    "empty": "مفيش حاجة هنا لسه",
    "emptyHint": "أضف أول مقال أو فيديو أو كورس بتتعلم منه.",
    "saveFailed": "ما اتحفظش — جرّب تانى",
    "markComplete": "علّم كمنتهى",
    "markIncomplete": "علّم كقيد التعلم",
    "suggestForTopic": "اقتراحات لـ {{topic}}",
    "suggestTitle": "اقتراحات لموضوع {{topic}}",
    "suggestLoading": "بنبحثلك على مصادر كويسة…",
    "suggestEmpty": "ما لقيناش حاجة — جرّب موضوع مختلف.",
    "fetchingMeta": "جارى جلب معلومات الرابط…",
    "added": "اتضاف",
    "bootstrapping": "بجيبلك مجموعة مصادر للسباحة دلوقتى…",
    "type": {
      "all": "الكل",
      "article": "مقال",
      "video": "فيديو",
      "lesson": "درس",
      "course": "كورس",
      "other": "غيره"
    },
    "fields": {
      "url": "الرابط",
      "title": "العنوان",
      "topic": "الموضوع",
      "topicPlaceholder": "مثلا: سباحة",
      "type": "النوع",
      "notes": "ملاحظات",
      "notesPlaceholder": "ليه المصدر ده مهم ليك (اختيارى)"
    }
  },
  "articleChat": {
    "cta": "اسأل AI عن المقال",
    "title": "اسأل AI",
    "placeholder": "اسأل أى حاجة عن المقال…"
  },
  "miniPlayer": {
    "popOut": "خلّيه شغّال أثناء التصفح",
    "expand": "كبّر",
    "close": "إغلاق المشغّل"
  },
  "assistant": {
    "tile": "المساعد",
    "title": "مساعد فينيكس",
    "subtitle": "اسأل عن أى حاجة فى بياناتك",
    "placeholder": "اكتب سؤالك…",
    "send": "ابعث",
    "thinking": "بفكّر…",
    "error": "حصل خطأ: {{error}}",
    "suggestionsHint": "جرّب واحد من دول:",
    "clearChat": "امسح المحادثة"
  },
  "insights": {
    "title": "ملخّص ذكى للأسبوع",
    "emptyHint": "الملخّص الأسبوعى هيظهر هنا يوم الأحد، أو ابدأ توليده دلوقتى.",
    "generateNow": "ابدأ الآن",
    "status": {
      "no_activity": "مفيش نشاط متسجّل كفاية الأسبوع ده للمراجعة.",
      "llm_failed": "مزوّد الـ AI فشل — جرب تانى بعد دقيقة.",
      "empty_response": "الـ AI رجع فاضى — جرب تانى.",
      "write_failed": "اتولّد بس معرفناش نحفظه — جرب تانى."
    },
    "refresh": "أعد توليد الملخّص",
    "expand": "اقرأ المزيد",
    "collapse": "اعرض أقل",
    "translate": "ترجم",
    "showOriginal": "النص الأصلى"
  },
  "common": {
    "confirm": "تأكيد",
    "cancel": "إلغاء",
    "close": "إغلاق",
    "save": "حفظ",
    "saving": "جارى الحفظ…",
    "add": "إضافة",
    "confirmDelete": "تحذف العنصر ده؟",
    "edit": "تعديل",
    "delete": "حذف",
    "actions": "خيارات",
    "clear": "إزالة",
    "show": "عرض",
    "hide": "إخفاء"
  },
  "journey": {
    "title": "الرحلة",
    "subtitle": "سجل خاص",
    "tableMissing": "الرحلة مش جاهزة دلوقتى. جرّب بعد دقيقة.",
    "stats": {
      "title": "آخر 7 / 30 يوم",
      "resistanceRate7": "نسبة المقاومة · 7 أيام",
      "resistanceRate30": "نسبة المقاومة · 30 يوم",
      "daysSinceLapse": "أيام بدون انتكاسة",
      "noLapseYet": "ما فيش انتكاسات مسجّلة",
      "checkins": "تسجيلات",
      "topTriggers": "أكتر المثيرات (30 يوم)"
    },
    "voice": {
      "title": "يوميات بصوتك",
      "placeholder": "اتكلم أو اكتب اللي في دماغك…",
      "mic": "سجّل",
      "save": "احفظ",
      "saved": "اتحفظت — استخرجنا:",
      "failed": "معرفناش نحفظها — جرب تاني."
    },
    "checkin": {
      "title": "تسجيل اليوم",
      "mood": "المزاج",
      "energy": "الطاقة",
      "urgesToday": "حصلت رغبة اليوم",
      "noUrges": "ما حصلتش رغبات اليوم",
      "notesPlaceholder": "إزاى كان اليوم؟ (اختياري)"
    },
    "urge": {
      "title": "سجل الرغبات",
      "add": "تسجيل رغبة",
      "empty": "ما فيش رغبات مسجّلة. كل رغبة — اتغلبت عليها أو لأ — معلومة بتساعدك تتعلّم.",
      "intensity": "الشدة (1 ضعيفة – 5 قوية)",
      "response": "إيه اللى حصل؟",
      "resisted": "اتغلبت عليها",
      "lapsed": "انتكست",
      "triggerPlaceholder": "إيه اللى أثارها؟ (ملل، توتر، scrolling، إلخ)",
      "notesPlaceholder": "حاجة تانية تستحق ملاحظة؟ (اختياري)",
      "confirmDelete": "حذف التسجيلة؟"
    }
  },
  "ai": {
    "thinking": "بفكّر…",
    "refresh": "تحديث",
    "retry": "حاول تانى",
    "errorTitle": "ما قدرتش أوصل للـ AI",
    "workoutCoach": {
      "title": "مدرّب التمارين",
      "description": "تحليل ذكى لآخر 30 يوم تمارين عند الطلب. خصوصيتك محفوظة — ما بيوصلش لبياناتك الماليّة أو الصحيّة.",
      "cta": "اطلب رأى المدرّب"
    },
    "mealCoach": {
      "title": "مدرّب الوجبات",
      "description": "تحليل ذكى لآخر 14 يوم وجبات + أهداف الماكروز عند الطلب. خصوصيتك محفوظة — ما بيوصلش لبياناتك الماليّة أو الصحيّة.",
      "cta": "اطلب رأى المدرّب"
    },
    "history": {
      "title": "تحليلات سابقة ({{count}})",
      "confirmDelete": "حذف التحليل ده؟",
      "tableMissing": "حفظ التحليلات السابقة مش جاهز دلوقتى."
    }
  },
  "newsSubs": {
    "title": "اشتراكاتى",
    "sources": "المصادر",
    "sourcesEmpty": "مفيش اشتراكات فى مصادر لسه. افتح صفحة أى مصدر واختار نوع الإشعار.",
    "topics": "المواضيع",
    "topicsEmpty": "مفيش اشتراكات فى مواضيع لسه. ضيف كلمة مفتاحية تحت.",
    "addTopicHint": "اشترك فى كلمة مفتاحية أو tag. بيطابق فى عناوين المقالات والـ tags والفئات.",
    "topicPlaceholder": "مثلاً: هجرة، فيزا، MacBook…",
    "addTopic": "أضف"
  },
  "newsSource": {
    "notFound": "المصدر مش موجود.",
    "articles": "مقالة",
    "notifyMe": "اشعارات",
    "modeOff": "إيقاف",
    "modeDaily": "ملخص يومى",
    "modeInstant": "فورى",
    "modeOffHint": "مش هتجيلك أى إشعارات من المصدر ده.",
    "modeDailyHint": "إشعار واحد الساعة ١٢ ظهراً بكل اللى نزل من اشتراكاتك.",
    "modeInstantHint": "إشعار لكل مقالة جديدة من المصدر ده (حد أقصى ٨ كل فحص).",
    "latestArticles": "أحدث المقالات",
    "empty": "ما فيش مقالات من المصدر ده لسه."
  },
  "social": {
    "title": "السوشيال"
  },
  "tech": {
    "title": "تكنولوجيا"
  },
  "news": {
    "title": "الأخبار",
    "openSourcePage": "افتح صفحة {{name}} (اشتراك + إشعارات)",
    "empty": "ما فيش مقالات مخزّنة لسه.",
    "emptyHint": "شغّل fetch-news من Edge Functions أو استنى الـ cron الجاى.",
    "savedEmpty": "ما فيش حاجة محفوظة لسه.",
    "savedEmptyHint": "اضغط الـ bookmark على أى مقال علشان ترجعله بعدين.",
    "savedShowOnly": "اعرض المحفوظات بس",
    "savedShowAll": "اعرض كل المقالات",
    "readEmpty": "ما فيش مقالات اتقرأت لسه.",
    "readEmptyHint": "أى مقال تفتحه — أو تعلّمه بعلامة العين — هيظهر هنا.",
    "markAsRead": "علّم كمقروء",
    "markAsUnread": "علّم كغير مقروء",
    "read": "مقروء",
    "unread": "مش مقروء",
    "reddit": {
      "sortNew": "الأحدث",
      "sortTop": "الأعلى",
      "topComment": "أبرز كومنت",
      "crosspostFrom": "منقول من {{sub}}",
      "silent": "صامت",
      "commentsTitle": "الكومنتات",
      "commentsLoading": "جارى تحميل الكومنتات…",
      "commentsEmpty": "مفيش كومنتات لسه.",
      "commentsError": "تحميل الكومنتات فشل: {{error}}",
      "translateAll": "ترجم",
      "showOriginal": "إظهار الأصلى",
      "translateError": "الترجمة فشلت: {{error}}",
      "refreshComments": "تحديث الكومنتات",
      "cachedHint": "آخر تحديث: {{time}}",
      "searchOnReddit": "ابحث على Reddit",
      "searching": "جارى البحث على Reddit…",
      "externalResults": "نتايج من Reddit",
      "externalBadge": "من Reddit",
      "clearExternal": "إخفاء نتايج Reddit",
      "searchError": "البحث على Reddit فشل: {{error}}"
    },
    "loadMore": "حمّل أكتر",
    "allLoaded": "وصلت لآخر مقال.",
    "view": {
      "all": "الكل",
      "read": "المقروء",
      "saved": "المحفوظ"
    },
    "filters": {
      "toggle": "إظهار/إخفاء الفلاتر",
      "title": "الفلاتر"
    },
    "fetchNow": {
      "label": "تحديث الآن",
      "success": "{{count}} مقال جديد",
      "successEmpty": "محدث — مفيش جديد",
      "error": "ما قدرناش نحدّث، جرّب بعد دقيقة"
    },
    "search": {
      "label": "بحث",
      "placeholder": "ابحث فى العناوين والمقتطفات…"
    },
    "digest": {
      "title": "ملخّص اليوم",
      "weeklyTitle": "ملخّص الأسبوع",
      "articlesShort": "خبر",
      "expand": "اقرأ المزيد",
      "collapse": "اعرض أقل",
      "refresh": "أعد توليد الملخّص",
      "translate": "ترجم",
      "showOriginal": "النص الأصلى"
    },
    "trending": {
      "title": "الأكثر تداولاً"
    },
    "lastFetched": "آخر تحديث من {{time}}",
    "tableMissing": "الأخبار مش جاهزة دلوقتى. جرّب بعد دقيقة.",
    "youtube": {
      "title": "يوتيوب",
      "allChannels": "كل القنوات",
      "searchPlaceholder": "ابحث فى الفيديوهات…",
      "clearSearch": "مسح البحث",
      "searchEmpty": "مفيش فيديوهات تطابق \"{{query}}\"",
      "searchEmptyHint": "جرّب كلمة تانية أو امسح البحث.",
      "empty": "مفيش فيديوهات لسه",
      "emptyHint": "آخر فيديوهات القنوات اللى مشترك فيها هتظهر هنا.",
      "tabAll": "الكل",
      "tabVideos": "فيديوهات",
      "tabShorts": "شورتس",
      "tabSaved": "المحفوظات",
      "tabHistory": "السجل",
      "historyEmpty": "مفيش سجل مشاهدة لسه",
      "historyEmptyHint": "الفيديوهات اللى تتفرج عليها من هنا هتظهر فى السجل علشان ترجعلها بعدين.",
      "historyCount": "{{count}} فيديو فى السجل",
      "clearHistory": "مسح السجل",
      "clearHistoryConfirm": "مسح كل سجل مشاهدتك على يوتيوب؟",
      "live": "مباشر",
      "views": "{{count}} مشاهدة",
      "viewsShort": "{{count}}",
      "searchOnYouTube": "ابحث على يوتيوب",
      "searchingYouTube": "جارى البحث على يوتيوب…",
      "externalResults": "نتايج من يوتيوب",
      "externalBadge": "من يوتيوب",
      "clearExternal": "إخفاء نتايج يوتيوب",
      "searchError": "البحث فى يوتيوب فشل: {{error}}",
      "save": "احفظ للوقت اللى بعدين",
      "saved": "اتحفظ — افتح من المحفوظات"
    },
    "health": {
      "title": "حالة المصادر",
      "healthy": "سليم",
      "degraded": "متذبذب",
      "failing": "فاشل",
      "disabled": "معطّل",
      "articles7d": "{{count}} فى 7 أيام",
      "lastFetched": "منذ {{time}}",
      "failures": "{{count}} فشل",
      "enable": "تشغيل",
      "disable": "إيقاف",
      "emptyFilter": "ما فيش مصادر تطابق ده.",
      "notOwnerTitle": "للمالك فقط",
      "notOwnerDescription": "صفحة حالة المصادر متاحة لمالك التطبيق فقط.",
      "refreshTags": "تحديث التاجات",
      "enriching": "جارى التصنيف…",
      "refreshTagsHint": "تشغيل يدوى لتصنيف الأخبار.",
      "refreshTagsResult": "تم تصنيف {{tagged}}/{{processed}} عبر {{providers}}",
      "filter": {
        "all": "الكل",
        "problems": "فيها مشاكل",
        "disabled": "متعطّلة"
      }
    },
    "lang": {
      "label": "اللغة",
      "all": "كل اللغات",
      "ar": "عربى",
      "en": "إنجليزى"
    },
    "sourceKind": {
      "label": "المصدر",
      "all": "كل المصادر",
      "news": "أخبار",
      "reddit": "Reddit",
      "youtube": "YouTube",
      "mastodon": "Mastodon",
      "bluesky": "Bluesky"
    },
    "subSource": {
      "label": "مصدر محدد",
      "all": "الكل"
    },
    "category": {
      "label": "التصنيف",
      "all": "الكل",
      "world": "عالمى",
      "ai": "ذكاء صناعى",
      "tech": "تكنولوجيا",
      "science": "علوم",
      "sports": "رياضة",
      "rights": "حقوق",
      "local": "محلى",
      "business": "أعمال"
    },
    "recentMatches": "نتائج المباريات",
    "viewAllMatches": "كل المباريات",
    "tag": {
      "breaking": "عاجل",
      "analysis": "تحليل",
      "interview": "حوار",
      "listicle": "قائمة",
      "review": "مراجعة",
      "announcement": "إعلان",
      "video": "فيديو",
      "social": "اجتماعى",
      "science": "علوم",
      "sports": "رياضة",
      "politics": "سياسة",
      "finance": "اقتصاد",
      "tech": "تكنولوجيا"
    },
    "article": {
      "notFound": "الخبر مش موجود.",
      "aiSummary": "ملخص AI",
      "aiSummaryTranslate": "ترجم الملخص",
      "aiSummaryShowOriginal": "اعرض الأصلى",
      "noSummary": "مفيش مقتطف متاح — افتح المصدر علشان تقرا الخبر كامل.",
      "noSocialBody": "نص المنشور مش متخزّن. افتح المصدر لقراءته كامل.",
      "loadingContent": "بنحمّل النص الكامل…",
      "extractFailed": "ما قدرناش نطلع النص الكامل. ده الـ excerpt بتاع الـ RSS.",
      "fallbackExcerpt": "Excerpt من الـ RSS:",
      "refetch": "إعادة تحميل النص",
      "readFullOnSource": "افتح على {{source}}",
      "source": "المصدر",
      "save": "احفظ للقراءة لاحقاً",
      "unsave": "إلغاء الحفظ",
      "muteSource": "اكتم {{source}}",
      "unmuteSource": "إلغاء الكتم {{source}}",
      "similarTitle": "مقالات مشابهة",
      "readingMinutes_one": "دقيقة قراءة",
      "readingMinutes_two": "دقيقتان قراءة",
      "readingMinutes_few": "{{count}} دقايق قراءة",
      "readingMinutes_many": "{{count}} دقيقة قراءة",
      "readingMinutes_other": "{{count}} دقيقة قراءة",
      "ttsPlay": "استمع",
      "ttsPause": "إيقاف مؤقت",
      "ttsResume": "إكمال الاستماع",
      "ttsStop": "إيقاف",
      "translateAction": "ترجم المقال",
      "translating": "بنترجم المقال للعربى…",
      "translatedAuto": "تمت الترجمة",
      "translationFailed": "الترجمة فشلت",
      "showOriginal": "اعرض الأصل",
      "showTranslation": "اعرض الترجمة",
      "retry": "إعادة المحاولة"
    }
  },
  "sports": {
    "title": "المباريات",
    "filterAll": "كل الدوريات",
    "filterFavourites": "المفضلة",
    "filterMyTeams": "فرقى",
    "filterMyTeamsHint_one": "اعرض بس مباريات فريق واحد مفضل",
    "filterMyTeamsHint_two": "اعرض بس مباريات فريقين مفضلين",
    "filterMyTeamsHint_few": "اعرض بس مباريات {{count}} فرق مفضلة",
    "filterMyTeamsHint_many": "اعرض بس مباريات {{count}} فريق مفضل",
    "filterMyTeamsHint_other": "اعرض بس مباريات {{count}} فريق مفضل",
    "favourite": "أضف للمفضلة",
    "unfavourite": "إزالة من المفضلة",
    "leaguesLabel": "الدوريات",
    "myTeamsLabel": "فرقى",
    "filtersOpen": "فتح الفلاتر",
    "viewStandings": "الترتيب",
    "tableMissing": "الرياضة مش جاهزة دلوقتى. جرّب بعد دقيقة.",
    "groups": {
      "live": "مباشر",
      "today": "اليوم",
      "tomorrow": "غدًا",
      "later": "قادمة"
    },
    "empty": {
      "title": "مفيش مباريات لسه",
      "description": "استنى شويه — هتظهر هنا أول ما الـ cron يجيب البيانات.",
      "descriptionTeams": "مفيش أى فريق من فرقك المفضلة له ماتش فى الـ 7 أيام الجاية."
    },
    "hero": {
      "title": "ماتش فريقك الجاى",
      "soon": "هيبدأ قريب",
      "inHours_one": "خلال ساعة تقريباً",
      "inHours_two": "خلال ساعتين",
      "inHours_few": "خلال {{count}} ساعات",
      "inHours_many": "خلال {{count}} ساعة",
      "inHours_other": "خلال {{count}} ساعة",
      "inDays_one": "بكرة",
      "inDays_two": "بعد يومين",
      "inDays_few": "خلال {{count}} أيام",
      "inDays_many": "خلال {{count}} يوم",
      "inDays_other": "خلال {{count}} يوم"
    },
    "match": {
      "title": "المباراة",
      "notFound": "المباراة مش موجودة.",
      "matchday": "الجولة {{n}}",
      "kickoff": "وقت البداية",
      "goals": "الأهداف",
      "form": "آخر مباريات",
      "h2h": "المواجهات السابقة",
      "played": "اللعب",
      "addToCalendar": "إضافة للتقويم",
      "relatedNews": "أخبار عن الماتش",
      "lineupsUnavailable": "تشكيلة المباراة مش متاحة فى الـ free plan.",
      "statusLive": "مباشر",
      "statusFinished": "انتهت",
      "statusScheduled": "قادمة",
      "statusPostponed": "مؤجلة",
      "statusCancelled": "ملغية"
    },
    "team": {
      "title": "الفريق",
      "notFound": "الفريق مش موجود.",
      "website": "الموقع",
      "colours": "الألوان",
      "competitions": "البطولات",
      "upcoming": "ماتشات قادمة",
      "recent": "آخر ماتشات",
      "squad_one": "اللاعبون — لاعب واحد",
      "squad_two": "اللاعبون — لاعبين",
      "squad_few": "اللاعبون — {{count}} لاعبين",
      "squad_many": "اللاعبون — {{count}} لاعب",
      "squad_other": "اللاعبون — {{count}} لاعب",
      "home": "محلى",
      "away": "خارج"
    },
    "standings": {
      "title": "الترتيب",
      "team": "الفريق",
      "topScorers": "هدافو الدورى",
      "empty": "مفيش ترتيب متاح للبطولة دى دلوقتى."
    }
  },
  "reports": {
    "title": "التقارير",
    "subtitle": "تقرير Markdown شامل لكل الـ modules فى أى فترة.",
    "preset": "فترة جاهزة",
    "presets": {
      "thisWeek": "هذا الأسبوع",
      "last7": "آخر 7 أيام",
      "thisMonth": "هذا الشهر",
      "last30": "آخر 30 يوم",
      "custom": "مخصص"
    },
    "startDate": "من",
    "endDate": "إلى",
    "generate": "إنشاء التقرير",
    "includes": "كل تقرير بيشمل:",
    "includesWorkout": "تمارين — جلسات، حمل، سيتات، دقايق كارديو",
    "includesPhoenix": "فينيكس — تغير الوزن، نسبة المياه، الوجبات، متوسط السعرات/البروتين",
    "includesHealth": "صحة — التزام بالأدوية والفيتامينات، آخر القياسات الحيوية",
    "includesFinance": "ماليات — حركة الرصيد، الدخل، المصروفات، الأقساط، الصافى الشهرى، الأهداف",
    "includesVitals": "قياسات حيوية — الضغط، النبض، السكر بشكل زمنى",
    "includesPhases": "المراحل — المرحلة الحالية، السجل، أوزان الهدف",
    "includesLearning": "التعلم — الموارد المحفوظة مجمّعة حسب الموضوع",
    "includesJourney": "الرحلة — سجل خاص للأحداث، نسبة المقاومة، التسجيلات اليومية",
    "formatHint": "هيفتح قدامك على طول كـ preview. دوس طباعة عشان تحفظه PDF، أو تنزيل لو عايز ملف HTML.",
    "preview": "معاينة التقرير",
    "print": "طباعة",
    "download": "تنزيل",
    "missingTables": "التقرير اتعمل. بعض الـ sections اتخطّت لأن الجداول دى لسه مش متركّبة: {{tables}}. شغّل الـ migration المناسب علشان يتدرجوا فى التقرير."
  },
  "immigration": {
    "title": "هجرة",
    "subtitle": "ابحث عن الدول واتابع مسار هجرتك",
    "empty": "مفيش دول مضافة دلوقتى.",
    "notFound": "الدولة دى مش موجودة.",
    "openTracker": "افتح الـ tracker",
    "assistant": {
      "title": "مساعد الهجرة",
      "cta": "اسأل AI",
      "askAboutCountry": "اسأل AI عن {{country}}",
      "subtitlePerCountry": "اسأل أى حاجة عن الدولة دى — الفيز، التوقيتات، أهليتك",
      "intro": "اسأل أى حاجة عن خطة هجرتك — عندى ملفك ومالياتك والدول اللى بتتابعها كسياق كامل.",
      "placeholder": "اسأل أى حاجة…"
    },
    "pathway": {
      "title": "الخطوات بالترتيب",
      "subtitle": "اعرف الطريقة من البداية للنهاية. اضغط \"تابع\" عشان تنسخها فى milestones، أو \"التفاصيل\" للشرح الكامل.",
      "trackThis": "تابع",
      "alreadyTracking": "بتتابعها",
      "viewDetails": "التفاصيل"
    },
    "step": {
      "shortLabel": "خطوة {{n}}",
      "vendors": "مقدمو الخدمة الموصى بيهم",
      "pitfalls": "أخطاء شائعة",
      "tips": "نصايح من تجارب",
      "generating": "بنحضّر الشرح التفصيلى… ده بيحصل أول مرة بس، وبعدها بيتـ cache.",
      "generatedOn": "تم التحضير فى {{date}}",
      "fresh": "جديد",
      "refresh": "إعادة التحضير"
    },
    "tracker": {
      "subtitle": "المستندات والمحطات والتكاليف",
      "docs": {
        "title": "المستندات",
        "empty": "مفيش مستندات لسه — ضيف أول واحد.",
        "namePlaceholder": "مثلاً: IELTS Academic، توثيق الشهادة…",
        "expires": "تنتهى",
        "sharedAcrossCountries": "ينطبق على كل الدول (مثل الجواز)"
      },
      "docStatus": {
        "not_started": "لم يبدأ",
        "in_progress": "جارى",
        "obtained": "تم الحصول",
        "expired": "انتهى"
      },
      "docCategory": {
        "identity": "هوية",
        "education": "تعليم",
        "language": "لغة",
        "experience": "خبرة عملية",
        "financial": "مالى",
        "medical": "طبى",
        "general": "عام"
      },
      "milestones": {
        "title": "المحطات",
        "empty": "مفيش محطات لسه — ضيف تاريخ مستهدف.",
        "namePlaceholder": "مثلاً: امتحان IELTS، تقديم Express Entry…",
        "target": "مستهدف",
        "done": "تم"
      },
      "milestoneStatus": {
        "planned": "مخطط",
        "in_progress": "جارى",
        "completed": "تم",
        "blocked": "معطل"
      },
      "costs": {
        "title": "التكاليف",
        "empty": "مفيش تكاليف لسه — ضيف مصروف مخطط أو متدفع.",
        "namePlaceholder": "مثلاً: رسم IELTS، تقييم WES…",
        "amountPlaceholder": "المبلغ بالريال السعودى",
        "alreadyPaid": "اتدفع بالفعل",
        "markPaid": "تأشير كمتدفع",
        "markUnpaid": "تأشير كغير متدفع",
        "totals": "متدفع / إجمالى"
      },
      "costCategory": {
        "visa_fee": "رسم فيزا",
        "translation": "ترجمة",
        "exam": "امتحان",
        "apostille": "توثيق",
        "travel": "سفر",
        "consultancy": "استشارة",
        "equipment": "معدات",
        "other": "أخرى"
      }
    },
    "tolerance": "التسامح",
    "stability": "الاستقرار",
    "years": "سنين",
    "statusLabel": "الحالة",
    "quickFacts": "نظرة سريعة",
    "citizenshipPath": "طريق الجنسية",
    "languages": "اللغات",
    "monthlyCost": "تكلفة المعيشة الشهرية",
    "dualCitizenship": "الجنسية المزدوجة",
    "visaPaths": "طرق الفيزا الرئيسية",
    "pros": "المميزات",
    "cons": "اعتبارات",
    "officialLinks": "روابط رسمية",
    "notes": "ملاحظاتى",
    "notesPlaceholder": "ملاحظات خاصة بيا عن الدولة دى…",
    "pin": "ثبّت",
    "unpin": "إلغاء التثبيت",
    "status": {
      "researching": "بحث",
      "interested": "مهتم",
      "pursuing": "بشتغل عليها",
      "not_interested": "مش مناسبة"
    }
  },
  "dues": {
    "title": "مستحقات الشهر الجاى",
    "empty": "مفيش حاجة تتدفع للشهر الجاى.",
    "netTotal": "الصافى المطبّق",
    "confirmSelected": "ادفع {{count}}",
    "newBalance": "الرصيد الجديد",
    "success": "تم تأكيد {{count}} عملية",
    "statusUnsettled": "ميعاد الاستحقاق يوم {{day}}",
    "statusPending": "بانتظار المراجعة",
    "statusConfirmed": "اتدفع للشهر الجاى",
    "kind": {
      "installment": "الأقساط",
      "fixed_expense": "مصروفات ثابتة",
      "special_obligation": "التزامات خاصة",
      "income": "الدخل"
    },
    "banner": {
      "title_one": "{{count}} بند مستحق للشهر الجاى",
      "title_other": "{{count}} بنود مستحقة للشهر الجاى",
      "title": "{{count}} بنود مستحقة للشهر الجاى",
      "subtitle": "اضغط للمراجعة والدفع المسبق"
    }
  },
  "finance": {
    "title": "الماليات",
    "audit": {
      "title": "مراجعة المتكرر",
      "run": "حلّل",
      "rerun": "حلّل تاني",
      "hint": "الـ AI بيبص على مصاريفك الثابتة والأقساط والالتزامات — إيه النايم أو الغالي أو اللي قرب يخلص.",
      "failed": "التحليل فشل — جرب تاني.",
      "empty": "مفيش مصاريف متكررة تتراجع لسه.",
      "recurringTotal": "المتكرر الشهري:",
      "ofIncome": "من الدخل:"
    },
    "dashboard": {
      "currentBalance": "الرصيد الحالي",
      "asOf": "بتاريخ {{date}}",
      "editBalance": "تعديل الرصيد",
      "monthlyIncome": "الدخل الشهري",
      "monthlyOutflow": "المصاريف الشهرية",
      "monthlyInstallments": "الأقساط",
      "monthlyNet": "الصافي الشهري",
      "expectedEnd": "متوقع نهاية الشهر: {{amount}} ريال",
      "risk": {
        "safe": "المنطقة الآمنة",
        "warning": "خد بالك",
        "critical": "منطقة خطر"
      }
    },
    "balance": {
      "amount": "المبلغ (ريال)",
      "date": "بتاريخ",
      "notes": "ملاحظة (اختياري)",
      "notesPlaceholder": "مثلاً: بعد المرتب",
      "history": "تاريخ الرصيد"
    },
    "income": {
      "title": "الدخل",
      "add": "إضافة مصدر دخل",
      "empty": "ما فيش مصادر دخل.",
      "name": "اسم المصدر",
      "amount": "المبلغ",
      "receiveDay": "اليوم في الشهر",
      "confirmDelete": "حذف مصدر الدخل؟",
      "frequencies": {
        "monthly": "شهري",
        "yearly": "سنوي",
        "one_time": "مرة واحدة"
      }
    },
    "fixed": {
      "title": "المصاريف الثابتة",
      "add": "إضافة مصروف",
      "empty": "ما فيش مصاريف ثابتة.",
      "name": "اسم المصروف",
      "amount": "المبلغ",
      "chargeDay": "يوم الخصم في الشهر",
      "chargeDayShort": "يوم {{day}}",
      "confirmDelete": "حذف المصروف؟",
      "categories": {
        "family": "عيلة",
        "transportation": "مواصلات",
        "utilities": "فواتير",
        "subscriptions": "اشتراكات",
        "other": "أخرى"
      }
    },
    "variable": {
      "title": "المصاريف المتغيرة",
      "amount": "تقدير شهري (ريال)",
      "notes": "بيغطي إيه"
    },
    "installments": {
      "title": "الأقساط",
      "add": "إضافة قسط",
      "empty": "ما فيش أقساط فعالة.",
      "provider": "المزود",
      "label": "تسمية (اختياري)",
      "monthlyAmount": "القسط الشهري",
      "remaining": "شهور متبقية",
      "total": "إجمالي الشهور",
      "day": "اليوم",
      "monthsLeft": "متبقي",
      "lastMonth": "آخر شهر",
      "confirmDelete": "حذف القسط؟"
    },
    "obligations": {
      "title": "التزامات خاصة",
      "add": "إضافة التزام",
      "empty": "ما فيش التزامات خاصة.",
      "name": "الاسم",
      "amount": "المبلغ",
      "totalMonths": "إجمالي الشهور",
      "remainingMonths": "متبقي",
      "startDate": "تاريخ البداية",
      "endDate": "تاريخ النهاية",
      "nextPaymentDate": "تاريخ الدفعة الجاية",
      "nextPayment": "الدفعة الجاية",
      "payoutStatus": "حالة القبض",
      "payoutDate": "تاريخ القبض",
      "goalLink": "هدف مرتبط",
      "notes": "ملاحظات",
      "monthsPaid": "شهر مدفوع",
      "confirmDelete": "حذف الالتزام؟",
      "kinds": {
        "swimming": "سباحة",
        "jam3eya": "جمعية",
        "rent": "إيجار",
        "custom": "مخصص"
      },
      "frequencies": {
        "monthly": "شهري",
        "every_6_months": "كل 6 شهور",
        "one_time": "مرة واحدة"
      },
      "payoutStatuses": {
        "pending": "لسه ما اتقبضش",
        "received": "اتقبض"
      }
    },
    "forecast": {
      "title": "توقعات 12 شهر",
      "viewTable": "جدول",
      "viewChart": "رسم بياني",
      "income": "دخل",
      "fixed": "ثابت",
      "variable": "متغير",
      "installments": "أقساط",
      "obligations": "التزامات",
      "net": "صافي",
      "balance": "الرصيد",
      "lastDeduction": "آخر خصم",
      "chartLegend": "الرصيد المتراكم · الخطوط المتقطعة = حد 5k / 1k"
    },
    "targets": {
      "title": "الأهداف",
      "achievementsTitle": "الإنجازات",
      "add": "إضافة هدف",
      "empty": "ما فيش أهداف فعالة.",
      "name": "اسم الهدف",
      "targetValue": "المبلغ المستهدف (ريال)",
      "targetDate": "موعد مستهدف",
      "expectedBy": "متوقع لـ",
      "achievedOn": "اتحقق في",
      "markAchieved": "تعيين كمحقق",
      "missed": "فات الموعد",
      "notesPlaceholder": "ملاحظة (اختياري)",
      "confirmAchieve": "تعيين الهدف كمحقق؟",
      "confirmDelete": "حذف الهدف؟",
      "types": {
        "balance_threshold": "حد الرصيد",
        "obligation_complete": "خلاص التزام",
        "all_installments_complete": "خلاص الأقساط كلها",
        "all_obligations_complete": "خلاص الالتزامات كلها",
        "ongoing_rule": "قاعدة مستمرة",
        "custom": "مخصص"
      }
    },
    "alerts": {
      "forecast": {
        "critical": "منطقة خطر قادمة",
        "warning": "خد بالك",
        "body": "متوقع الرصيد نهاية {{month}}: {{amount}} ريال"
      },
      "upcoming": {
        "installmentTitle": "خصم {{label}} قريب",
        "obligationTitle": "دفعة {{label}} قريبة"
      }
    },
    "upcoming": {
      "title": "ال 30 يوم الجاية",
      "today": "النهاردة",
      "tomorrow": "بكرة",
      "daysAway": "يوم"
    },
    "balanceChart": {
      "title": "الرصيد عبر الزمن",
      "balance": "الرصيد"
    }
  },
  "healthProfile": {
    "title": "الملف الصحي",
    "todayDoses": {
      "title": "جرعات اليوم"
    },
    "medication": {
      "title": "الأدوية",
      "add": "إضافة دواء",
      "empty": "ما فيش أدوية مسجّلة.",
      "name": "الاسم",
      "dosage": "الجرعة",
      "frequency": "التكرار",
      "scheduleTimes": "مواعيد اليوم",
      "scheduleHint": "بنظام ٢٤ ساعة، افصل بفاصلة (مثال: 08:00, 20:00)",
      "startedAt": "بدأت في",
      "reminders": "إرسال تذكيرات في المواعيد",
      "notes": "ملاحظات",
      "confirmDelete": "حذف الدواء؟",
      "streak": "{{n}}",
      "streakA11y": "سلسلة {{n}} يوم",
      "frequencies": {
        "daily": "يوميًا",
        "twice_daily": "مرتين يوميًا",
        "three_daily": "ثلاث مرات يوميًا",
        "weekly": "أسبوعيًا",
        "as_needed": "عند الحاجة"
      }
    },
    "supplement": {
      "title": "فيتامينات ومكملات",
      "add": "إضافة فيتامين/مكمل",
      "empty": "ما فيش فيتامينات أو مكملات مسجّلة.",
      "name": "الاسم",
      "dosage": "الجرعة",
      "frequency": "التكرار",
      "scheduleTimes": "مواعيد اليوم",
      "scheduleHint": "بنظام ٢٤ ساعة، افصل بفاصلة (مثال: 08:00, 20:00)",
      "startedAt": "بدأت في",
      "reminders": "إرسال تذكيرات في المواعيد",
      "notes": "ملاحظات",
      "confirmDelete": "حذف الفيتامين/المكمل؟",
      "streak": "{{n}}",
      "streakA11y": "سلسلة {{n}} يوم",
      "frequencies": {
        "daily": "يوميًا",
        "twice_daily": "مرتين يوميًا",
        "three_daily": "ثلاث مرات يوميًا",
        "weekly": "أسبوعيًا",
        "as_needed": "عند الحاجة"
      }
    },
    "vitals": {
      "title": "المؤشرات الحيوية",
      "addReading": "تسجيل قراءة",
      "empty": "ما فيش قراءات مسجّلة.",
      "confirmDelete": "حذف القراءة؟",
      "notes": "ملاحظات",
      "context": {
        "label": "الحالة",
        "fasting": "صائم",
        "pre_meal": "قبل الأكل",
        "post_meal": "بعد الأكل",
        "before_bed": "قبل النوم",
        "other": "أخرى"
      },
      "bp": {
        "title": "ضغط الدم",
        "systolic": "العلوي",
        "diastolic": "السفلي",
        "unit": "mmHg"
      },
      "hr": {
        "title": "نبض القلب وقت الراحة",
        "bpm": "BPM"
      },
      "glucose": {
        "title": "سكر الدم",
        "value": "القيمة",
        "unit": "mg/dL"
      }
    },
    "condition": {
      "title": "الحالات الصحية",
      "add": "إضافة حالة",
      "empty": "ما فيش حالات مسجّلة.",
      "name": "الاسم",
      "diagnosedAt": "تاريخ التشخيص",
      "doctor": "الدكتور",
      "active": "حالة نشطة حاليًا",
      "notes": "ملاحظات",
      "confirmDelete": "حذف الحالة؟"
    }
  },
  "breadcrumb": {
    "label": "مسار التنقل",
    "home": "الرئيسية",
    "workout": "التمارين",
    "history": "السجل",
    "session": "الجلسة",
    "library": "المكتبة",
    "exercise": "التمرين",
    "templates": "القوالب",
    "newSession": "جلسة جديدة",
    "phases": "المراحل",
    "settings": "الإعدادات",
    "profile": "البروفايل",
    "habits": "العادات",
    "physique": "تحليل الجسم",
    "sleep": "تظبيط النوم",
    "goalPace": "إيقاع الهدف",
    "quizHistory": "السجل",
    "editProfile": "تعديل الملف",
    "news": "الأخبار",
    "social": "السوشيال",
    "tech": "تكنولوجيا",
    "newsHealth": "حالة المصادر",
    "article": "المقال",
    "gamesWordle": "وردل",
    "gamesQuestions": "أسئلة",
    "gamesQuiz": "كويز",
    "gamesSpy": "جاسوس",
    "scoreboard": "النتايج",
    "youtube": "يوتيوب",
    "health": "الملف الصحى",
    "learning": "التعلم",
    "english": "إنجليزى",
    "englishVocab": "الكلمات",
    "englishReview": "مراجعة",
    "englishCourse": "الكورس",
    "englishTutor": "المدرّس",
    "englishSpeak": "النطق",
    "messages": "الرسائل",
    "message": "الرسالة",
    "friends": "الأصدقاء",
    "lifeSearch": "دوّر في حياتك",
    "people": "الناس",
    "wishlist": "نفسي أشتري",
    "moments": "لقطاتنا",
    "momentsCapture": "الكاميرا",
    "momentsArchive": "السجل",
    "momentsDay": "اليوم",
    "momentsDigest": "ملخص الشهر",
    "reading": "القراءة",
    "readingNew": "إضافة كتاب",
    "readingBook": "كتاب",
    "readingRecap": "ملخص الربع",
    "readingCatalog": "كتب مجانية",
    "readingRead": "بقرأ",
    "tab": {
      "today": "الرئيسية",
      "weight": "الوزن",
      "water": "الماء",
      "meals": "الوجبات",
      "measurements": "القياسات",
      "photos": "الصور",
      "progress": "التقدم"
    }
  },
  "settings": {
    "title": "الإعدادات",
    "back": "رجوع",
    "close": "إغلاق",
    "crumb": "الإعدادات",
    "replayTour": "أعد الجولة التعريفية",
    "sections": {
      "preferences": "التفضيلات",
      "appearance": "المظهر",
      "voice": "الصوت",
      "briefing": "ملخص الصبح",
      "notifications": "الإشعارات",
      "profile": "الملف الشخصي",
      "training": "التمارين",
      "app": "التطبيق",
      "developer": "التطوير"
    },
    "briefing": {
      "location": "مكان الطقس",
      "current": "الحالي:",
      "cityPlaceholder": "دوّر على مدينة… \"جدة\"",
      "useGps": "استخدم موقعي",
      "myLocation": "موقعي",
      "sectionsTitle": "عايز تسمع إيه",
      "sections": {
        "weather": "الطقس",
        "news": "الأخبار",
        "finance": "الفلوس",
        "training": "التمرين",
        "habits": "العادات",
        "goals": "الأهداف"
      },
      "interestsTitle": "اهتماماتك في الأخبار",
      "interestsHint": "مواضيع مفصولة بفاصلة — الملخص هيذكر بس العناوين اللي تخصها.",
      "interestsPlaceholder": "تقنية، كرة قدم، AI…"
    },
    "app": {
      "checkUpdates": {
        "label": "تحقّق من التحديثات",
        "description": "اعمل تحديث يدوي للتطبيق علشان تجيب آخر نسخة. استخدمها لو سمعت إن في feature جديدة لسه ما ظهرتلكش — الصفحة بتعمل reload بعد ٣ ثواني تقريباً."
      }
    },
    "voice": {
      "englishLabel": "الصوت الإنجليزى",
      "englishSample": "Hi! This is a sample of my voice — tap me on a vocab card to hear me read.",
      "arabicLabel": "الصوت العربى",
      "arabicSample": "أهلاً! ده مثال من صوتى. اضغط على أى كلمة فى التطبيق علشان تسمعنى.",
      "previewing": "جارٍ التشغيل…"
    },
    "developer": {
      "aiDebug": {
        "label": "لوحة تشخيص الـ AI",
        "description": "تعرض الـ status و الـ headers و الـ body الخام تحت كل AI card. مفيدة لما الـ AI يفشل على الموبايل."
      },
      "aiThinking": {
        "label": "تفكير الـ AI",
        "description": "خلّى الموديل يـ reason قبل ما يردّ. كلفته ~4× وأبطأ بـ 4-9 ثوانى، تحسّن طفيف فى الـ prompts البسيطة. مقفول افتراضى."
      },
      "showAiProvider": {
        "label": "إظهار اسم مزود الـ AI",
        "description": "يعرض اسم الموديل (gemini / groq / cerebras) تحت كل ردّ. للمالك فقط — مقفول افتراضى."
      },
      "debugLog": {
        "label": "سجل التشخيص داخل التطبيق",
        "description": "بيلتقط الـ console + الأخطاء + الاستثناءات فى سجل ثابت داخل التطبيق علشان تقدر تنسخه وتبعتهولى لما Safari مش بيقولك سبب المشكلة."
      },
      "testUpdate": {
        "label": "اختبار مودال التحديث",
        "description": "بيشغّل حدث pwa:update-available بشكل مزيّف علشان مودال التحديث الموسّط يظهر دلوقتي. اضغط علشان تتأكد إنه فعلًا مش هيتقفل بالنقر بره؛ زر التحديث بيعمل reload للصفحة بعد ٣ ثواني تقريبًا."
      },
      "testCelebration": {
        "label": "اختبار احتفال الفوز",
        "description": "بيشغّل نفس انفجار الكونفيتي اللي بيظهر لما تحلّ وردل النهارده — انفجارين من ركني التحتي + انفجار خفيف في النص بعدها بـ ٣٠٠ ميلي تقريبًا. مفيد علشان نضبط الألوان والكثافة."
      },
      "sendPush": {
        "section": "ابعت إشعار",
        "recipient": "المستلم",
        "title": "العنوان",
        "titlePlaceholder": "مثلاً: تطمن عليّا",
        "body": "نص الرسالة",
        "bodyPlaceholder": "اكتب اللي عاوز توصّله.",
        "url": "افتح الرابط ده عند الضغط",
        "send": "ابعت",
        "sending": "بيتبعت…"
      }
    },
    "appearance": {
      "theme": "الوضع",
      "themeLight": "نهاري",
      "themeDark": "ليلي",
      "themeBlack": "ليلي أسود",
      "autoTheme": "تبديل تلقائى حسب الوقت",
      "autoThemeHint": "نهارى من 6 صباحًا لـ 6 مساءً، وليلى بعد كده.",
      "autoThemeNightHint": "بيتطبق بالليل بس — النهار دايمًا نهارى.",
      "primaryColor": "اللون الأساسي",
      "font": "الخط"
    }
  },
  "reminders": {
    "title": "تذكير يومي",
    "description": "سنذكّرك مرة في اليوم بتسجيل بياناتك.",
    "time": "عند",
    "enable": "تفعيل التذكيرات",
    "disable": "إيقاف التذكيرات",
    "permissionBlocked": "الإشعارات محظورة. فعّلها من إعدادات المتصفح.",
    "iosInstallRequired": "ثبّت التطبيق على شاشتك الرئيسية لتفعيل التذكيرات على iOS.",
    "sendTest": "إرسال اختبار",
    "testSent": "تم الإرسال — افحص إشعاراتك.",
    "testFailed": "فشل الاختبار: {{detail}}",
    "showLocal": "عرض محلي",
    "localTestBody": "لو شفت الإشعار ده، فالإشعارات على iOS شغّالة.",
    "localTestSent": "تم عرض الإشعار المحلي — افحص شاشتك.",
    "localTestFailed": "فشل الإشعار المحلي: {{detail}}",
    "diagnostics": {
      "title": "الحالة",
      "permission": "إذن المتصفح",
      "permission_granted": "مسموح",
      "permission_denied": "محجوب — افتحه من إعدادات الموقع في المتصفح",
      "permission_default": "ما اتطلبش لسه",
      "subscribed": "الاشتراك مسجل",
      "subscribed_yes": "شغّال",
      "subscribed_no": "مش مشترك — اضغط تفعيل فوق",
      "testLocal": "جرّب على الجهاز ده"
    },
    "moreKinds": "تذكيرات إضافية",
    "kinds": {
      "meals": {
        "title": "سجّل وجباتك",
        "subtitle": "تذكير في المساء لو ما سجلتش أي وجبة",
        "enable": "تفعيل تذكير الوجبات",
        "disable": "إيقاف تذكير الوجبات"
      },
      "water": {
        "title": "اشرب مياهك",
        "subtitle": "تذكير لو لسه ما وصلتش لهدفك اليومي",
        "enable": "تفعيل تذكير المياه",
        "disable": "إيقاف تذكير المياه"
      },
      "birthday": {
        "title": "عيد الميلاد",
        "subtitle": "هنسلّم عليك الظهر",
        "enable": "تفعيل تذكير عيد الميلاد",
        "disable": "إيقاف تذكير عيد الميلاد"
      },
      "sleep": {
        "title": "تظبيط النوم",
        "subtitle": "تنبيهات الميلاتونين والـ wind-down والصحيان في مواعيد الخطة",
        "enable": "تفعيل تذكيرات النوم",
        "disable": "إيقاف تذكيرات النوم"
      }
    }
  },
  "profile": {
    "openMenu": "فتح قائمة الملف الشخصي",
    "greeting": "أهلاً، {{name}} 👋",
    "fallbackName": "صديقي",
    "ageLine": "العمر {{age}} · عيد الميلاد بعد {{days}} يوم",
    "ageLineToday": "العمر {{age}} · عيد ميلاد سعيد! 🎂",
    "completeProfile": "أكمل ملفك الشخصي ←",
    "userId": "معرّف المستخدم",
    "themeLight": "الوضع الفاتح",
    "themeDark": "الوضع الداكن",
    "editProfile": "تعديل الملف الشخصي / الأهداف",
    "workouts": "التمارين",
    "measurements": "القياسات",
    "signOut": "تسجيل الخروج",
    "avatar": {
      "title": "صورة البروفايل",
      "pickPrompt": "اختار صورة من جهازك.",
      "pick": "اختار صورة",
      "pickAnother": "غيّر الصورة",
      "previewHint": "هتتقص الصورة لمربع من النص.",
      "save": "استخدم الصورة دي",
      "uploading": "بيترفع…",
      "saveFailed": "ما اتحفظتش — اتأكد من النت وحاول تاني."
    },
    "editPage": {
      "title": "البروفايل",
      "changePhoto": "غيّر الصورة",
      "name": "الاسم",
      "namePh": "ننادي عليك إزاي؟",
      "birthday": "تاريخ الميلاد",
      "sex": "النوع",
      "sex_male": "ذكر",
      "sex_female": "أنثى",
      "sex_other": "غير ذلك",
      "height": "الطول ({{unit}})",
      "save": "حفظ التغييرات",
      "saving": "بيتحفظ…",
      "saved": "اتحفظ"
    }
  },
  "workout": {
    "title": "التمارين",
    "subtitle": "تمرّن بذكاء، سجّل بسرعة.",
    "uploading": "جاري الرفع…",
    "dashboard": {
      "firstRunTitle": "جهّز مكتبتك",
      "firstRunDesc": "هنحضّر تمارين افتراضية لأيام 1 و 2 و 3 عشان تبدأ التسجيل فورًا.",
      "setupCta": "إضافة التمارين الافتراضية",
      "seeding": "جاري الإعداد…",
      "libraryCard": "مكتبة التمارين",
      "libraryCardDesc": "{{count}} تمرين",
      "startCard": "ابدأ تمرين",
      "startCardDesc": "سجّل السيتات والكارديو والإحساس.",
      "historyCard": "سجل الجلسات",
      "historyCardDesc": "تصفح الجلسات السابقة",
      "templatesCard": "القوالب",
      "templatesCardDesc": "عدّل قوائم أيام 1/2/3"
    },
    "history": {
      "title": "سجل الجلسات",
      "subtitle": "الأحدث أولًا.",
      "empty": "مفيش جلسات لسه — ابدأ تمرينك الأول من الداشبورد.",
      "summary": "{{exercises}} تمرين · {{sets}} سيت · {{volume}} كجم",
      "summaryCardio": "{{cardio}} دقيقة كارديو",
      "duration": "{{min}} دقيقة",
      "bodyWeight": "{{kg}} كجم وزن",
      "exportMarkdown": "تصدير Markdown"
    },
    "sessionDetail": {
      "title": "الجلسة",
      "notFound": "الجلسة غير موجودة",
      "edit": "تعديل الجلسة",
      "delete": "حذف الجلسة",
      "totalCalories": "إجمالي السعرات",
      "confirmDelete": "حذف هذه الجلسة؟",
      "confirmDeleteDesc": "كل السيتات وسجلات الكارديو في الجلسة هتتمسح.",
      "saveAsTemplate": "حفظ كقالب",
      "saveAsTemplateConfirm": "تستبدل قالب {{day}}؟",
      "saveAsTemplateConfirmDesc": "جلسات {{day}} الجاية هتبدأ بنفس التمارين دي وبنفس الترتيب.",
      "saveAsTemplateSuccess": "تم حفظ القالب",
      "saveAsTemplateError": "حصلت مشكلة وما اتحفظش",
      "notes": "ملاحظات",
      "energyLabel": "الطاقة",
      "bodyWeight": "وزن الجسم",
      "duration": "المدة",
      "startTime": "وقت البداية",
      "exercises": "التمارين",
      "cardio": "كارديو",
      "noLogs": "مفيش تمارين متسجّلة",
      "warmupTag": "إحماء",
      "failureTag": "فشل"
    },
    "templates": {
      "title": "القوالب",
      "subtitle": "اختار اللي يتحمّل لما تبدأ جلسة يوم 1/2/3.",
      "day1_chest_back": "اليوم 1 — صدر وظهر",
      "day2_arms_shoulders": "اليوم 2 — أكتاف وذراعين",
      "day3_legs": "اليوم 3 — أرجل",
      "empty": "مفيش تمارين لسه — ضيف واحد.",
      "moveUp": "تحريك لأعلى",
      "moveDown": "تحريك لأسفل",
      "remove": "إزالة",
      "add": "إضافة تمرين",
      "saving": "جاري الحفظ…"
    },
    "pr": {
      "title": "الأرقام القياسية",
      "heaviest": "الأثقل",
      "bestSet": "أفضل سيت",
      "mostReps": "أكتر عدّات",
      "heaviestValue": "{{weight}} كجم × {{reps}}",
      "bestSetValue": "{{volume}} كجم",
      "mostRepsValue": "{{reps}} × {{weight}} كجم"
    },
    "chart": {
      "title": "التقدم",
      "yAxis": "كجم",
      "tooltipTop": "أعلى سيت: {{weight}} كجم × {{reps}}",
      "notEnoughData": "سجّل جلستين على الأقل لتشوف مخطط التقدم.",
      "recentSessions": "الجلسات الأخيرة",
      "noRecent": "مفيش جلسات لسه."
    },
    "session": {
      "title": "جلسة جديدة",
      "editTitle": "تعديل الجلسة",
      "pickType": "اختر نوع الجلسة",
      "save": "حفظ الجلسة",
      "saving": "جاري الحفظ…",
      "savedToast": "تم حفظ الجلسة",
      "updatedToast": "تم تحديث الجلسة",
      "resumePromptTitle": "تكمل المسودة السابقة؟",
      "resumePromptDesc": "عندك جلسة لسه ما تحفظتش.",
      "resume": "كمل",
      "discard": "تجاهل",
      "addExercise": "إضافة تمرين",
      "addCardio": "إضافة كارديو",
      "removeExercise": "إزالة التمرين",
      "removeExerciseConfirm": "إزالة هذا التمرين من الجلسة؟",
      "moveUp": "تحريك لأعلى",
      "moveDown": "تحريك لأسفل",
      "exerciseNotes": "ملاحظات التمرين",
      "exerciseNotesPlaceholder": "تنبيهات الفورم، الإيقاع، إلخ.",
      "previewExercise": "معاينة {{name}}",
      "lastSet": "آخر مرة: {{weight}}كجم × {{reps}}",
      "noHistory": "لسه مفيش سجل",
      "recentSessions": "آخر ٣ سيشنز",
      "emptyError": "ضيف تمرين واحد على الأقل أو بلوك كارديو.",
      "saveError": "ما قدرناش نحفظ الجلسة: {{message}}",
      "missingExercise": "(محذوف من المكتبة)"
    },
    "sessionType": {
      "day1_chest_back": "اليوم 1 — صدر وظهر",
      "day1_chest_back_desc": "صدر وظهر",
      "day2_arms_shoulders": "اليوم 2 — أكتاف وذراعين",
      "day2_arms_shoulders_desc": "أكتاف، باي، تراي",
      "day3_legs": "اليوم 3 — أرجل",
      "day3_legs_desc": "كوادز، هام، بطة، كور",
      "swim": "سباحة",
      "swim_desc": "تمرين في المسبح",
      "cardio_only": "كارديو فقط",
      "cardio_only_desc": "تخطّى الأوزان وسجّل كارديو",
      "custom": "مخصص",
      "custom_desc": "ابنِ جلستك من الصفر"
    },
    "set": {
      "header": "#",
      "weight": "الوزن (كجم)",
      "reps": "العدّات",
      "rpe": "الجهد",
      "warmup": "إحماء",
      "failure": "فشل",
      "add": "إضافة سيت",
      "remove": "إزالة السيت",
      "invalidReps": "العدّات لازم تكون أكبر من صفر"
    },
    "cardio": {
      "title": "كارديو",
      "type": "النوع",
      "duration": "المدة (دقيقة)",
      "level": "المستوى",
      "incline": "الميل (%)",
      "speed": "السرعة (كم/س)",
      "distance": "المسافة (كم)",
      "calories": "السعرات",
      "notes": "ملاحظات",
      "notesPlaceholder": "أي حاجة تستاهل تتفكر…",
      "invalidDuration": "المدة لازم تكون أكبر من صفر"
    },
    "cardioType": {
      "elliptical": "إلبتيكال",
      "treadmill_walk": "مشاية — مشي",
      "treadmill_run": "مشاية — جري",
      "treadmill_intervals": "مشاية — إنترفال",
      "bike": "دراجة ثابتة",
      "stairmaster": "ستيرماستر",
      "swim": "سباحة"
    },
    "cardioPresets": {
      "title": "خطط سريعة",
      "hrBadge": "≤{{bpm}} ن/د"
    },
    "meta": {
      "toggle": "تفاصيل الجلسة",
      "bodyWeight": "وزن الجسم (كجم)",
      "bodyWeightHint": "تم تعبئته من آخر قياس",
      "energy": "الطاقة (1-10)",
      "startTime": "وقت البداية",
      "duration": "المدة (دقيقة)",
      "notes": "ملاحظات الجلسة",
      "notesPlaceholder": "إحساسك كان إيه؟"
    },
    "picker": {
      "title": "اختر تمرين",
      "close": "إغلاق",
      "empty": "مكتبتك فاضية — حضّر التمارين الافتراضية من الداشبورد الأول."
    },
    "exercises": {
      "title": "التمارين",
      "subtitle": "مكتبتك من الحركات والأجهزة.",
      "addNew": "إضافة",
      "edit": "تعديل",
      "archive": "أرشفة التمرين",
      "confirmArchive": "أرشفة هذا التمرين؟",
      "confirmArchiveDesc": "هيتخفي من المكتبة. السيتات السابقة اللي بتشير ليه هتفضل موجودة.",
      "searchPlaceholder": "بحث…",
      "filterAll": "الكل",
      "noResults": "مفيش تمارين مطابقة.",
      "notFound": "التمرين غير موجود",
      "noPhoto": "مفيش صورة لسه — اضغط تعديل لإضافة واحدة.",
      "form": {
        "name": "الاسم",
        "muscleGroup": "العضلة",
        "equipmentType": "المعدات",
        "photo": "صورة الجهاز",
        "uploadPhoto": "اضغط لرفع صورة",
        "setupNotes": "ملاحظات الإعداد",
        "setupPlaceholder": "ارتفاع المقعد، الزاوية، وضع اليد…",
        "save": "حفظ"
      },
      "detail": {
        "setupNotes": "ملاحظات الإعداد",
        "historyComingSoon": "مخطط التقدم والسجل يجوا في الإصدار القادم."
      }
    },
    "muscleGroup": {
      "chest": "الصدر",
      "back": "الظهر",
      "shoulders": "الأكتاف",
      "biceps": "البايسبس",
      "triceps": "الترايسبس",
      "quads": "الفخذ الأمامي",
      "hamstrings": "الفخذ الخلفي",
      "glutes": "الأرداف",
      "core": "البطن",
      "full_body": "الجسم بالكامل"
    },
    "equipment": {
      "barbell": "بار",
      "dumbbell": "دامبل",
      "machine": "ماكينة",
      "cable": "كابل",
      "bodyweight": "وزن الجسم",
      "smith": "سميث"
    }
  },
  "loadingPage": {
    "title": "بيقوم من جديد...",
    "subtitle": "بنحضّر فينكس تراكر بتاعك"
  },
  "physique": {
    "title": "تحليل الجسم",
    "album": {
      "title": "ألبوم التقدم",
      "empty": "ضيف صور تقدم خاصة مع الوقت — وبعدين اختار أي صورتين والـ AI يحكيلك اتغير إيه فعلاً.",
      "compare": "قارن الصورتين المختارتين",
      "failed": "المقارنة فشلت — جرب تاني.",
      "pose": {
        "front": "أمامي",
        "side": "جانبي",
        "back": "خلفي"
      }
    },
    "intro": "ابعت صورة والـ AI هيقولك تركّز على إيه.",
    "pick": "اختار صورة",
    "tryAnother": "جرّب صورة تانية",
    "analyzing": "بيحلّل…",
    "privacy": "صورتك مش بتتخزّن — بتتحلّل وتتمسح على طول.",
    "strengths": "نقاط القوة",
    "focusAreas": "ركّز على",
    "tips": "نصايح تمرين",
    "history": "تحاليل سابقة",
    "failed": "ماقدرش يحلّلها — جرّب صورة واضحة للجسم كامل.",
    "notPerson": "دي مش شكلها صورة جسم. جرّب صورة واضحة للجسم كامل.",
    "disclaimer": "إرشاد للتمرين بس — مش نصيحة طبية أو صحية."
  },
  "goalPace": {
    "title": "إيقاع الهدف",
    "settings": "الإعدادات",
    "sevenDayAvg": "متوسط الوزن (7 أيام)",
    "daysLeft": "باقي {{n}} يوم",
    "todayRaw": "النهاردة {{v}}",
    "weeklyRate": "المعدّل الأسبوعي",
    "bandHint": "النطاق الصحي: {{min}}–{{max}} {{unit}}/أسبوع",
    "projected": "المتوقّع في تاريخ الهدف:",
    "chartTitle": "المتوسط الأسبوعي مقابل الهدف",
    "avgLine": "متوسط 7 أيام",
    "targetLine": "الهدف",
    "levers": "روافع يومية",
    "steps": "الخطوات",
    "stepTarget": "الهدف {{min}}–{{max}}",
    "logSteps": "سجّل خطوات النهاردة",
    "today": "النهاردة",
    "avg7": "متوسط 7 أيام",
    "protein": "البروتين",
    "proteinTarget": "الهدف {{g}} جم/يوم",
    "streak": "متتالية",
    "buildingBaseline": "بنبني خط الأساس",
    "buildingBaselineHint": "{{n}} من {{need}} قياسات. كمّل تسجيل — الاتجاه محتاج أسبوعين قبل ما يبقى له معنى.",
    "targetDate": "تاريخ الهدف",
    "baselineWeight": "وزن البداية ({{unit}})",
    "baselineDate": "تاريخ البداية",
    "goalWeight": "وزن الهدف ({{unit}})",
    "optional": "اختياري",
    "note": {
      "tooFast": "الفقدان بقى أسرع من النطاق المستدام لأكتر من أسبوعين. ده بيزوّد خطر فقدان العضل والطاقة — فكّر تخفّف العجز. الأسرع مش أحسن هنا.",
      "aggressive": "الهدف ده محتاج معدّل أسرع من الصحّي في الوقت المتبقّي. الوزن الواقعي بحلول تاريخك حوالي {{weight}}. التاريخ مش حائط — ده مجرّد التوقّع الصادق.",
      "behind": "متأخّر شوية عن الإيقاع. الرافعة هي خطوات أكتر وتحقيق هدف البروتين — مش إنك تاكل أقل."
    }
  },
  "sleep": {
    "title": "تظبيط النوم",
    "endPlan": "إنهاء الخطة",
    "setupIntro": "هنزّبط نومك بالتدريج لمعاد أحسن — بدري شوية كل خطوة، وتفضل ثابتة لحد ما جسمك يتعوّد.",
    "current": "إنت دلوقتي بتنام إمتى",
    "target": "عايز توصل لإيه",
    "bedtime": "معاد النوم",
    "wake": "معاد الصحيان",
    "shiftIncrement": "التقديم كل خطوة",
    "holdDays": "أيام كل خطوة",
    "melatoninOffset": "الميلاتونين قبل النوم بـ",
    "dose": "جرعة الميلاتونين",
    "minutes": "دقيقة",
    "days": "يوم",
    "hours": "ساعة",
    "startPlan": "ابدأ الخطة",
    "disclaimer": "إرشاد عام للصحة، مش نصيحة طبية. استشير دكتور قبل ما تاخد ميلاتونين.",
    "todayTargets": "أهداف الليلة",
    "stepN": "خطوة {{n}}",
    "daysToTarget": "{{n}} يوم للهدف",
    "melatonin": "ميلاتونين",
    "doseHint": "الجرعة: {{dose}}",
    "morningLight": "اتعرّضت لشمس الصبح",
    "melatoninTaken": "أخدت الميلاتونين",
    "windDownDone": "عملت الـ wind-down",
    "story": {
      "title": "حدوتة قبل النوم",
      "generate": "احكيلي",
      "another": "واحدة تانية",
      "writing": "بكتب…",
      "play": "شغّل",
      "pause": "وقّف مؤقت",
      "stop": "اقفل",
      "failed": "معرفناش نكتبها — جرب تاني.",
      "showText": "وريني النص",
      "theme": {
        "calm": "هدوء",
        "journey": "رحلتي",
        "reading": "كتابي"
      }
    },
    "logNight": "سجّل ليلة امبارح",
    "actualBedtime": "نمت فعلاً الساعة",
    "actualWake": "صحيت فعلاً الساعة",
    "quality": "جودة النوم",
    "todayAdherence": "الالتزام:",
    "streakN": "{{n}} يوم متواصل",
    "maintenance": "محافظة",
    "maintenanceTitle": "وصلت لمعاد نومك المستهدف",
    "taperHint": "حافظ على الإيقاع ده. تقدر تبدأ تقلّل الميلاتونين دلوقتي — جرّب تنزّل الجرعة للنص، وبعدين توقّفها لما نومك يثبت.",
    "chartTitle": "اتجاه معاد النوم",
    "chartTarget": "الهدف {{time}}"
  },
  "habits": {
    "title": "العادات",
    "manage": "إدارة العادات",
    "empty": "مفيش عادات لسه. ضيف واحدة وابدأ تبني streak.",
    "add": "ضيف عادة",
    "editTitle": "تعديل العادة",
    "namePlaceholder": "مثلاً: تمرين، قراية، صلاة…",
    "icon": "أيقونة",
    "color": "لون",
    "streakN": "{{n}} يوم متتابع",
    "doneOfTotal": "{{done}}/{{total}} خلصت",
    "manageHint": "اضغط على العادة علشان تعلّمها خلصت النهارده."
  },
  "messages": {
    "list": {
      "title": "الرسائل",
      "startHint": "اضغط علشان تبدأ المحادثة",
      "empty": "مفيش محادثات لسه — ضيف أصدقاء علشان تبدأ."
    },
    "thread": {
      "empty": "مفيش رسائل مع {{name}} لسه — سلّم عليه 👋",
      "placeholder": "اكتب رسالة…",
      "thinkingOfYou": "بفكر فيك",
      "read": "اتقرأت",
      "sent": "اتبعتت",
      "typing": "بيكتب…",
      "online": "أونلاين",
      "actions": "إجراءات الرسالة",
      "edit": "تعديل",
      "unsend": "إلغاء الإرسال",
      "deleted": "الرسالة اتمسحت",
      "edited": "اتعدّلت",
      "reply": "رد",
      "replyingTo": "بترد على {{name}}",
      "you": "إنت",
      "attachImage": "ابعت صورة",
      "viewOnceMode": "وضع الصورة اللي تتفتح مرة",
      "tapToView": "اضغط علشان تشوفها ({{n}}×)",
      "viewOnceSent": "صورة تتفتح مرة ({{n}}×)",
      "imageSeen": "الصورة اتشافت — مبقتش متاحة",
      "notDelivered": "الإشعار ماوصلش",
      "notDeliveredRetry": "الإشعار ماتبعتش — جرّب تاني",
      "schedule": "جدوِل الإرسال",
      "scheduleTitle": "ابعت بعدين",
      "scheduleConfirm": "جدوِل",
      "scheduled": "مجدوَلة",
      "recordVoice": "سجّل رسالة صوتية",
      "recording": "بيسجّل…",
      "micDenied": "الميكروفون مرفوض — فعّله من إعدادات المتصفح."
    },
    "detail": {
      "title": "الرسالة",
      "from": "من {{name}}",
      "to": "إلى {{name}}",
      "openLink": "افتح الرابط"
    },
    "notFound": "الرسالة مش موجودة.",
    "gallery": {
      "title": "الصور المشتركة",
      "empty": "مفيش صور اتبعتت لسه."
    },
    "couple": {
      "title": "إنتوا الاتنين",
      "daysN": "{{n}} يوم مع بعض",
      "yourMood": "مزاجك النهارده",
      "anniversary": "مع بعض من"
    },
    "gate": {
      "aria": "رسالة جديدة",
      "fromLine": "من {{name}}",
      "openInbox": "افتح الرسائل",
      "close": "تمام",
      "moreCount": "في {{count}} رسالة تانية مستنية",
      "viewOncePhoto": "بعتلك صورة تتفتح مرة — افتح الشات علشان تشوفها"
    }
  },
  "briefing": {
    "play": "ملخص الصبح",
    "ready": "الملخص جاهز — دوس اسمع",
    "stop": "وقّف الملخص",
    "failed": "الملخص فشل — دوس جرب تاني"
  },
  "wishlist": {
    "title": "نفسي أشتري",
    "add": "ضيف",
    "empty": "ضيف الحاجات اللي بتفكر فيها — الـ AI يوزنها مع رصيدك وفايضك وأهدافك.",
    "namePlaceholder": "عايز تشتري إيه؟",
    "pricePlaceholder": "السعر (ريال)",
    "urlPlaceholder": "لينك (اختياري)",
    "notesPlaceholder": "ملاحظات…",
    "priority": { "1": "مهم", "2": "عادي", "3": "يستنى" },
    "advise": "أشتريهم دلوقتي ولا أستنى؟",
    "verdict": { "now": "اشتريها", "wait": "استنى", "skip": "سيبها" },
    "bought": "اشتريتها",
    "boughtList": "اللي اتشترى ({{count}})",
    "open": "افتح اللينك",
    "confirm": "متأكد؟"
  },
  "rewrite": {
    "title": "حسّن الكتابة",
    "undo": "رجّع الأصلي",
    "style": {
      "improve": "حسّنها",
      "formal": "رسمي",
      "casual": "عامي",
      "to_ar": "→ عربي",
      "to_en": "→ English"
    }
  },
  "fridge": {
    "title": "وصفات من تلاجتك",
    "snap": "صوّر التلاجة",
    "thinking": "بشوف…",
    "hint": "صوّر تلاجتك — الـ AI يقرا اللي فيها ويقترح ٣ أكلات تناسب أهدافك والمرحلة اللي انت فيها.",
    "failed": "معرفناش نقرا الصورة — جرب في إضاءة أحسن."
  },
  "people": {
    "title": "الناس",
    "add": "ضيف",
    "empty": "ضيف الناس اللي فعلاً مهمين — أعياد ميلاد ومعدل تواصل، وهننبهك لو حد سكت عن المعتاد.",
    "namePlaceholder": "الاسم",
    "relationPlaceholder": "القرابة… \"أخويا\"، \"صاحب شغل\"",
    "birthday": "عيد الميلاد",
    "cadence": "تواصل كل (يوم)",
    "notesPlaceholder": "ملاحظات — هدايا، آخر كلام…",
    "contacted": "تواصلت",
    "lastContact": "آخر تواصل:",
    "quiet": "ساكت {{count}} يوم زيادة عن المعتاد",
    "birthdayToday": "عيد ميلاده النهارده 🎂",
    "birthdayIn": "عيد ميلاده بعد {{count}} يوم",
    "confirm": "متأكد؟"
  },
  "onThisDay": {
    "title": "في يوم زي ده",
    "yearsAgo": "من {{count}} سنة",
    "weight": "وزنك كان {{weight}} كيلو",
    "moment": "لقطة متسجلة",
    "book": "خلصت كتاب \"{{title}}\""
  },
  "goals": {
    "title": "أهداف الربع",
    "add": "ضيف",
    "empty": "حط من ٣ لـ ٥ أهداف للربع ده — كل سبت الـ AI بيراجع انت وصلت فين فعلاً.",
    "titlePlaceholder": "الهدف… \"أوصل ٨٨ كيلو\"",
    "metricPlaceholder": "النجاح بيتقاس إزاي (اختياري)",
    "reviewTitle": "المراجعة الأسبوعية",
    "reviewPending": "أول مراجعة AI هتوصل صباح السبت.",
    "markDone": "خلصته",
    "reopen": "رجّعه",
    "confirm": "متأكد؟"
  },
  "lifeSearch": {
    "title": "دوّر في حياتك",
    "placeholder": "اسأل أي حاجة عن حياتك…",
    "hint": "بيدوّر في الوزن والوجبات والتمارين والمزاج والصحة والفلوس والعادات وأكتر.",
    "ex1": "آخر مرة رحت دكتور أسنان كانت امتى؟",
    "ex2": "أنهي أسابيع اتمرنت فيها أكتر من ٤ مرات؟",
    "ex3": "مزاجي اتغير إزاي الشهر اللي فات؟",
    "searching": "بدوّر في حياتك…",
    "failed": "البحث فشل — جرب تاني.",
    "noData": "مفيش بيانات مطابقة في الفترة دي.",
    "sourcesLabel": "المصادر:"
  },
  "quickCapture": {
    "button": "سجّل أي حاجة",
    "title": "تسجيل سريع",
    "placeholder": "اكتب أو اتكلم… \"شربت كوبايتين مياه\"، \"وزني ٩٢.٥\"، \"صرفت ٤٠ على قهوة\"",
    "submit": "سجّل",
    "mic": "اتكلم",
    "listening": "بسمعك…",
    "failed": "معرفناش نعالجها — جرب تاني.",
    "savedTo": "اتسجلت في {{module}} ✓",
    "inboxed": "اتحفظت في الصندوق — {{module}}",
    "inboxTitle": "الصندوق — تسجيلاتك السابقة",
    "inboxEmpty": "الصندوق فاضي لسه.",
    "multi": "أكتر من حاجة",
    "modules": {
      "weight": "الوزن",
      "water": "المياه",
      "meal": "الوجبات",
      "mood": "المزاج",
      "vital": "العلامات الحيوية",
      "expense": "مصروف",
      "note": "ملاحظة"
    }
  },
  "friends": {
    "title": "الأصدقاء",
    "myHandle": "اسم المستخدم بتاعك",
    "handlePlaceholder": "username",
    "displayNamePlaceholder": "الاسم اللي بيظهر",
    "handleHint": "من 3 لـ 20 حرف: حروف إنجليزي صغيرة وأرقام و _. أصحابك بيلاقوك بيه بالظبط.",
    "handleTaken": "الاسم ده متاخد.",
    "handleInvalid": "اسم مش صالح — من 3 لـ 20 حرف إنجليزي صغير أو أرقام أو _ بس.",
    "handleSaved": "اتحفظ ✓",
    "searchTitle": "ضيف صديق",
    "searchPlaceholder": "اسم المستخدم بالظبط",
    "suggestionsTitle": "اقتراحات ليك",
    "mutualCount": "أصدقاء مشتركين: {{count}}",
    "noMatch": "مفيش حد بالاسم ده.",
    "add": "ابعت طلب",
    "requestSent": "الطلب اتبعت ✓",
    "incoming": "طلبات صداقة",
    "outgoing": "طلبات بعتّها",
    "accept": "اقبل",
    "decline": "ارفض",
    "cancel": "الغي",
    "friendsList": "أصحابك",
    "empty": "مفيش أصدقاء لسه — دوّر باسم المستخدم فوق وضيف حد.",
    "message": "رسالة",
    "unfriend": "شيل الصداقة",
    "block": "ابلوك",
    "confirm": "متأكد؟",
    "blockedList": "محظورين",
    "unblock": "فك البلوك"
  },
  "moments": {
    "title": "لقطاتنا",
    "captureTitle": "اللقطة",
    "rules": "لما Phoenix ينبّهكم، عندكم 5 دقايق تصوّروا اللحظة بالكاميرا — كاميرا بس، مفيش معرض. ولا حد بيشوف اللي عند التاني غير لما يبعت لقطته.",
    "streakLabel": "يوم متواصل",
    "noPromptToday": "مفيش لقطة لسه النهارده. هتوصلك إشعار في وقتها.",
    "openCamera": "افتح الكاميرا",
    "windowClosingIn": "متبقي {{minutes}}د",
    "waitingForPartner": "مستنيين {{name}}…",
    "partnerMissed": "{{name}} ضيّع الفرصة",
    "youMissed": "ضيّعتها — في بكره.",
    "revealed": "اتكشفت",
    "cameraDenied": "الكاميرا مرفوضة",
    "cameraDeniedHint": "فعّل الكاميرا من إعدادات المتصفح علشان تصوّر.",
    "cameraUnavailable": "الكاميرا مش متاحة على الجهاز ده.",
    "captureFailed": "اللقطة فشلت — جرّب تاني.",
    "flipCamera": "قلب الكاميرا",
    "retry": "جرّب تاني",
    "shoot": "صوّر",
    "back": "رجوع",
    "backToIndex": "ارجع للقطاتنا",
    "you": "إنت",
    "lateBadge": "متأخر",
    "notFound": "اللحظة دي مبقتش متاحة.",
    "historyComingSoon": "اللقطات السابقة — قريب",
    "browseHistory": "اتفرّج على اللقطات السابقة",
    "archiveTitle": "اللقطات السابقة",
    "archiveEmpty": "مفيش لقطات لسه — أول واحدة جاية.",
    "archiveMissed": "ضاعت",
    "archiveSolo": "إنت بس",
    "reactWith": "تفاعل بـ {{emoji}}",
    "commentPlaceholder": "قول حاجة…",
    "sendComment": "ابعت تعليق",
    "digestNotFound": "مفيش ملخص للشهر ده لسه.",
    "digestEmpty": "شهر هادي — مفيش حاجة تتلخص.",
    "digestStats": {
      "moments": "لقطة",
      "longestStreak": "أطول سلسلة",
      "totalDays": "يوم متابعة"
    }
  },
  "reading": {
    "title": "القراءة",
    "addBook": "ضيف كتاب",
    "addBookTitle": "كتاب جديد",
    "addHighlight": "ضيف",
    "back": "رجوع",
    "delete": "احذف",
    "deleteHighlight": "احذف الاقتباس",
    "save": "احفظ",
    "confirmDelete": "تحذف الكتاب ده وكل اقتباساته؟",
    "notFound": "الكتاب مش موجود.",
    "emptyShelf": "الرف ده فاضي لسه.",
    "notesLabel": "ملاحظات",
    "notesPlaceholder": "أي حاجة عايز تفتكرها عن الكتاب…",
    "highlightsLabel": "اقتباسات",
    "highlightPlaceholder": "اكتب سطر من الكتاب…",
    "pageNumber": "صفحة",
    "page": "ص {{n}}",
    "fromShelf": "من رف {{name}}",
    "startedOn": "بدأ {{date}}",
    "finishedOn": "خلّص {{date}}",
    "status": {
      "wishlist": "قائمة الانتظار",
      "reading": "بقرأ",
      "finished": "خلّصت",
      "paused": "موقوف"
    },
    "fields": {
      "title": "العنوان",
      "author": "المؤلف",
      "status": "الحالة",
      "coverUrl": "رابط الغلاف",
      "coverUrlHint": "اختياري — حط لينك صورة الغلاف."
    },
    "file": {
      "label": "ملف الكتاب",
      "pick": "اختار ملف PDF أو EPUB",
      "attach": "أرفق ملف",
      "reattach": "أرفق الملف تاني",
      "replace": "استبدل الملف",
      "remove": "شيل الملف",
      "open": "افتح",
      "start": "ابدأ القراءة",
      "continue": "متابعة · {{n}}%",
      "missing": "ملف الكتاب ده على جهاز تاني — أرفقه هنا عشان تقراه على الجهاز ده.",
      "localOnly": "متخزّن على الجهاز ده بس.",
      "localOnlyHint": "PDF أو EPUB — بيتحفظ على الجهاز ده بس، من غير مزامنة.",
      "pickError": "ملفات PDF أو EPUB بس المدعومة.",
      "pdf": "PDF",
      "epub": "EPUB"
    },
    "progress": {
      "read": "مقروء {{n}}%",
      "lastRead": "آخر قراءة {{date}}"
    },
    "finishCta": "خلّصت الكتاب",
    "changeStatus": "تغيير الحالة",
    "aiSynthesisLabel": "خلاصة الكتاب",
    "aiSynthesisPending": "بنكتب الخلاصة…",
    "recapNotFound": "مفيش ملخص للربع ده لسه.",
    "recapEmpty": "ربع هادي — مفيش كتاب اتخلّص.",
    "recapBookCount": "كتاب اتخلّص",
    "recapPending": "الملخص بيتكتب…",
    "browseCatalog": "تصفّح",
    "catalogTitle": "كتب مجانية",
    "catalogEmpty": "مفيش نتايج — جرّب بحث تاني.",
    "searchPlaceholder": "ابحث بالعنوان أو المؤلف…",
    "searchGo": "ابحث",
    "loadMore": "كمان",
    "addToShelf": "ضيف للرف",
    "sources": {
      "archive": "عربي (أرشيف)",
      "gutenberg": "إنجليزي (جوتنبرج)"
    },
    "categories": {
      "recommended": "مختار",
      "novels": "روايات",
      "islamic": "إسلامي",
      "history": "تاريخ",
      "philosophy": "فلسفة",
      "poetry": "شعر",
      "romance": "رومانسي",
      "adventure": "مغامرات",
      "mystery": "غموض",
      "sciencefiction": "خيال علمي"
    },
    "seeAll": "اعرض الكل",
    "clearSearch": "مسح",
    "readBook": "اقرأ",
    "readerSettings": "إعدادات القراءة",
    "readerLoadFailed": "تعذّر تحميل النص.",
    "readerEmpty": "الكتاب ده فاضي.",
    "fontSize": "حجم الخط",
    "fontDecrease": "أصغر",
    "fontIncrease": "أكبر",
    "markFinished": "علّم كمنتهي",
    "saveSpot": "احفظ موضعي",
    "addSelectionHighlight": "ضيف كاقتباس",
    "previousPage": "الصفحة السابقة",
    "nextPage": "الصفحة التالية"
  },
  "games": {
    "title": "ألعاب",
    "spy": {
      "title": "جاسوس",
      "tabLabel": "جاسوس",
      "players": "اللاعبين",
      "playerPlaceholder": "لاعب {{n}}",
      "addPlayer": "ضيف لاعب",
      "removePlayer": "شيل اللاعب",
      "computerPlayers": "بوتات",
      "addBot": "ضيف لاعب كمبيوتر",
      "removeBot": "شيل لاعب كمبيوتر",
      "botName": "كمبيوتر {{n}}",
      "interrogate": "اسأل الكمبيوتر",
      "discussion": "النقاش",
      "askNow": "اسأل دلوقتي",
      "feedHint": "الكمبيوتر بيسأل لوحده — جاوب بصوتك أو ردّ هنا.",
      "replyPlaceholder": "ردّ على الكمبيوتر…",
      "nextQuestion": "السؤال اللي بعده",
      "replyToTarget": "ردّ على {{name}}…",
      "askPlaceholder": "اسأله حاجة… (أو دوس إرسال)",
      "botAsk": "خلّي الكمبيوتر يسأل سؤال",
      "botFailed": "…(مفيش رد — جرّب تاني)",
      "modeLocal": "موبايل واحد",
      "modeOnline": "أونلاين",
      "yourName": "اسمك",
      "createRoom": "اعمل غرفة",
      "joinRoom": "ادخل غرفة",
      "codePlaceholder": "الكود",
      "roomNotFound": "مفيش غرفة بالكود ده.",
      "roomInProgress": "اللعبة دي بدأت خلاص.",
      "roomCode": "كود الغرفة",
      "shareCode": "ابعت الكود ده علشان الباقيين يدخلوا.",
      "inviteFriends": "اعزم أصحابك",
      "invite": "اعزم",
      "invited": "اتبعتت ✓",
      "host": "المضيف",
      "waitingHost": "مستنيين المضيف يبدأ…",
      "voteWho": "مين الجاسوس؟",
      "computerTurn": "دور الكمبيوتر يسأل",
      "votes": "الأصوات",
      "leaveRoom": "اخرج من الغرفة",
      "roundTime": "وقت الجولة",
      "minutes": "{{n}} دقيقة",
      "start": "ابدأ الجولة",
      "needMore": "ضيف {{n}} لاعبين على الأقل علشان تبدأ.",
      "passTo": "سلّم الموبايل لـ{{name}}",
      "tapToReveal": "اضغط علشان تشوف كارتك",
      "youAreSpy": "إنت الجاسوس 🕵️",
      "spyHint": "اندمج مع الجماعة وحاول تعرف المكان.",
      "theLocation": "المكان",
      "yourRole": "دورك: {{role}}",
      "hideAndPass": "خبّيت، سلّمها للي بعديك",
      "startRound": "كلهم شافوا — ابدأ",
      "discussHint": "اسألوا بعض أسئلة. اكشفوا الجاسوس قبل ما الوقت يخلص.",
      "timeUp": "الوقت خلص! صوّتوا على الجاسوس.",
      "pause": "وقفة",
      "resume": "كمّل",
      "addMinute": "+دقيقة",
      "reveal": "اكشف الجاسوس",
      "theSpy": "الجاسوس كان",
      "theSpies": "الجواسيس كانوا",
      "playAgain": "العب تاني",
      "newSetup": "إعداد جديد",
      "howToTitle": "إزاي تلعب جاسوس",
      "how1": "ضيف من ٣ لـ٨ لاعبين وسلّموا الموبايل لبعض.",
      "how2": "كله بياخد نفس المكان السري — غير جاسوس أو اتنين مبياخدوش حاجة.",
      "how3": "بالتبادل اسألوا أسئلة ذكية عن المكان. متبقاش واضح أوي علشان الجاسوس ميعرفش.",
      "how4": "قبل ما الوقت يخلص، صوّتوا على مين الجاسوس. الجاسوس بيكسب لو عرف المكان أو فلت.",
      "gotIt": "تمام",
      "whoWon": "مين كسب الجولة دي؟",
      "outcomeCaught": "مسكنا الجاسوس",
      "outcomeGuessed": "الجاسوس عرف المكان",
      "outcomeEscaped": "الجاسوس فلت",
      "skipLog": "تخطّي — متسجّلش الجولة دي",
      "logged": "اتسجّلت الجولة",
      "scoreboard": "النتايج",
      "noResults": "مفيش جولات اتسجّلت لسه.",
      "bestBluffer": "أحسن نصّاب",
      "mostCaught": "الأكتر اتمسك",
      "spyWinsN": "{{n}} فوز كجاسوس",
      "caughtN": "اتمسك {{n}} مرة",
      "colPlayer": "اللاعب",
      "colGames": "جولات",
      "colSpyWins": "فوز كجاسوس",
      "colCaught": "اتمسك"
    },
    "quiz": {
      "title": "كويز",
      "tabLabel": "كويز",
      "howToPlay": "إزاي الكويز شغّال",
      "runningTally": "تخميناتك عن شريكك من بدري",
      "you": "إنت",
      "soloUnavailable": "الكويز محتاج اتنين — اعزم شريكك الأول.",
      "startBlurb": "كل جولة ٥ أسئلة، كل واحد يخمّن إجابة التاني. كام واحدة هتعرفها صح عن {{name}}؟",
      "startCta": "ابدأ جولة جديدة",
      "deckLabel": "النوع: {{name}}",
      "deck": {
        "preferences": { "name": "أذواق", "blurb": "أكل، جو، حاجات يومية" },
        "dreams":      { "name": "أحلام", "blurb": "المستقبل، البيت، أحلام بعيدة" },
        "goofy":       { "name": "هزار",  "blurb": "بيتزا، سناكس، حاجات خفيفة" },
        "memories":    { "name": "ذكريات","blurb": "الطفولة، آخر رحلة، الهدايا" },
        "spicy":       { "name": "رومانسي","blurb": "لغة الحب، خروجات، أسئلة دافية" },
        "deep":        { "name": "عميق",  "blurb": "قيم، معتقدات، فلسفة الحب" },
        "intimate":    { "name": "حميمي", "blurb": "الـ٣٦ سؤال اللي بيقرّبوا القلوب — مشاعر، ذكريات، أمنيات" },
        "surprise":    { "name": "فاجئني", "blurb": "سحب عشوائي من كل الأنواع" }
      },
      "questionN": "سؤال {{n}} من {{total}}",
      "yourAnswer": "إجابتك",
      "guessTheirs": "هو هيختار إيه في رأيك؟",
      "submitNext": "تسجيل واللي بعده",
      "submitFinal": "تسجيل وانتهاء الجولة",
      "submitting": "بيتسجل…",
      "submitFailed": "ما اتسجلش — اتأكد من النت وحاول تاني.",
      "abandonRound": "اخرج من الجولة دي واختار نوع تاني",
      "list": {
        "empty": "مفيش جولات شغّالة دلوقتي. ابدأ واحدة و{{name}} هيلاقيها — أو حدّث لو فيه جولة منتظر تلاقيها.",
        "refresh": "حدّث",
        "startNew": "ابدأ جولة جديدة",
        "history": "شوف الجولات اللي خلصتوها",
        "cardMyTurn": "دورك — جاوبت {{progress}}/{{total}}",
        "cardWaiting": "مستني {{name}} — هو في {{progress}}/{{total}}",
        "cardAbandon": "ألغي الجولة دي",
        "backToRounds": "ارجع للجولات",
        "abandonConfirmTitle": "تلغي الجولة دي؟",
        "abandonConfirmBody": "{{name}} مش هيشوف الجولة دي تاني. تقدر ترجعها فوراً بعد ما تأكّد.",
        "abandonConfirmYes": "أيوة، ألغي",
        "abandonConfirmCancel": "خلّيها",
        "undoToast": "اتلغت الجولة.",
        "undoCta": "تراجع"
      },
      "history": {
        "title": "الجولات اللي خلصتوها",
        "empty": "لسه ما خلصتوش جولة سوا. خلّصوا واحدة وهتلاقوها هنا."
      },
      "waitingOnPartner": "{{name}} لسه بيجاوب — النتيجة هتظهر لما تخلصوا الاتنين.",
      "bothDone": "خلصت الجولة — شوف عملت إيه",
      "knewAbout": "تخميناتك عن {{name}}",
      "guessedThem": "خمّنت إنه هيختار {{choice}}",
      "startAnother": "ابدأ جولة تانية",
      "playAnotherWhileWait": "العب جولة تانية وإنت مستني",
      "waitingPanelOne": "{{name}} لسه ما خلّصش الجولة. ممكن تستنى — أو تلعب جولة تانية.",
      "waitingPanelMany": "فيه {{count}} جولات مستنيين {{name}} يخلّصها.",
      "partnerProgressLine": "{{name}} على {{progress}} من {{total}}",
      "skipOne": "ألغي",
      "inFlightChip": "{{count}} مستنيين {{name}}",
      "revealBanner": "جولة جاهزة — اضغط تشوف النتيجة",
      "revealBannerMany": "{{count}} جولات جاهزة — اضغط تشوف النتايج",
      "howTo": {
        "line1": "كل جولة ٥ أسئلة. الاتنين بتجاوبوا نفس الخمسة.",
        "line2": "كل سؤال بتدوس على حاجتين: إجابتك إنت، وتخمينك لإجابة شريكك.",
        "line3": "النتيجة بتظهر لما الاتنين تخلصوا — بتورّيكم كل واحد عرف كام إجابة صح عن التاني.",
        "line4": "إجمالي تخميناتك الصحيحة بيظهر في إيقونة الكأس فوق.",
        "cta": "تمام"
      }
    },
    "questions": {
      "title": "سؤال اليوم",
      "tabLabel": "أسئلة",
      "howToPlay": "إزاي اللعبة بتشتغل",
      "streakLabel": "الأيام اللي جاوبتوا فيها سوا",
      "you": "إنت",
      "reveal": "إجاباتكم النهارده",
      "partnerNotStarted": "{{name}} لسه ما جاوبش",
      "partnerNotYet": "مستنيين {{name}}…",
      "partnerAnsweredWaiting": "{{name}} جاوب — دورك",
      "howTo": {
        "line1": "سؤال كل يوم، نفس السؤال للاتنين.",
        "line2": "اضغط على إجابتك. مش هتعرف تغيّرها — اختار اللي حاسس إنه حقيقي.",
        "line3": "اختيار شريكك بيفضل مخفي لحد ما الاتنين تختاروا.",
        "line4": "سؤال جديد كل يوم نص الليل، نفس السؤال ليكم الاتنين.",
        "cta": "تمام"
      },
      "suggest": {
        "cta": "اقترح سؤال ({{count}} في المجموعة)",
        "title": "اقترح سؤال",
        "category": "النوع",
        "questionEn": "السؤال (إنجليزي)",
        "questionEnPh": "What's your favourite snack?",
        "questionAr": "السؤال (عربي)",
        "questionArPh": "إيه السناك المفضل؟",
        "options": "الخيارات (٣ لـ ٥، اللغتين)",
        "addOption": "خيار تاني",
        "removeOption": "احذف الخيار",
        "submit": "ضيفه للمجموعة",
        "submitting": "بيتسجل…",
        "submitFailed": "ما اتسجلش — اتأكد من النت وحاول تاني."
      }
    },
    "wordle": {
      "title": "وردل",
      "tabLabel": "وردل",
      "streakLabel": "أيام متتالية",
      "modeDaily": "اليوم",
      "modePractice": "تدريب",
      "modePracticeNext": "كلمة جديدة",
      "practiceMode": "وضع التدريب — مش بيتحسب في السلسلة",
      "practiceHint": "جولات التدريب مش بتتسجّل ومش بتأثر على سلسلتك.",
      "playAgain": "لعب تاني",
      "share": "شير",
      "copied": "اتنسخ",
      "copyFailed": "مقدرناش ننسخ — اضغط مطوّل علشان تنسخ يدوي.",
      "notEnough": "الحروف ناقصة",
      "notInList": "الكلمة مش في القاموس",
      "youWon_one": "حلّيتها في تخمينة واحدة.",
      "youWon_two": "حلّيتها في تخمينتين.",
      "youWon_few": "حلّيتها في {{count}} تخمينات.",
      "youWon_many": "حلّيتها في {{count}} تخمينة.",
      "youWon_other": "حلّيتها في {{count}} تخمينة.",
      "youLost": "حظ أحسن بكره. الكلمة كانت {{answer}}.",
      "lostAnswer": "الكلمة كانت {{answer}}.",
      "shareTitleDaily": "فينكس وردل {{date}} {{score}}",
      "shareTitlePractice": "فينكس وردل تدريب {{score}}",
      "howToPlay": "إزاي تلعب",
      "win": {
        "1": "عبقري",
        "2": "بطولة",
        "3": "تحفة",
        "4": "ممتاز",
        "5": "حلوة",
        "6": "لحقت بشق الأنفس"
      },
      "howTo": {
        "line1": "خمّن الكلمة المكوّنة من ٥ حروف في ٦ محاولات.",
        "line2": "كل تخمينة لازم تكون كلمة فعلًا — اضغط Enter علشان تسجّلها.",
        "green": "الحرف موجود في الكلمة وفي مكانه الصح.",
        "yellow": "الحرف موجود في الكلمة بس في مكان غلط.",
        "gray": "الحرف مش موجود في الكلمة.",
        "daily": "كلمة جديدة كل يوم نص الليل — نفس الكلمة ليك ولشريكك.",
        "cta": "تمام"
      },
      "partner": {
        "you": "إنت",
        "jointStreak_one": "يوم سوا",
        "jointStreak_two": "يومين سوا",
        "jointStreak_few": "{{count}} أيام سوا",
        "jointStreak_many": "{{count}} يوم سوا",
        "jointStreak_other": "{{count}} يوم سوا",
        "not_started": "{{name}} لسه ما بدأش",
        "playing": "{{name}} بيلعب دلوقتي…",
        "won": "{{name}} خلّص — هتعرف عدد محاولاته لما تخلّص إنت كمان",
        "lost": "{{name}} ما عرفش يحلّها النهارده"
      },
      "scoreboard": {
        "title": "نتايج النهارده"
      }
    }
  },
  "footer": {
    "madeWith": "صنع بـ",
    "by": "بواسطة",
    "allRights": "جميع الحقوق محفوظة."
  },
  "hairRoutine": {
    "title": "روتين الشعر",
    "subtitle": "جدول العناية الأسبوعي ودليل المنتجات",
    "weeklyRoutine": "الروتين الأسبوعي",
    "schedule": "الجدول",
    "weeklyRoutineDesc": "روتين العناية بالشعر حسب أيام الأسبوع",
    "productUsageGuide": "دليل استخدام المنتجات",
    "products": "المنتجات",
    "productUsageDesc": "تعليمات مفصلة لكل منتج في روتين العناية بالشعر",
    "proTips": "💡 نصائح احترافية",
    "proTipsDesc": "تذكر هذه النقاط الأساسية للعناية المثلى بالشعر",
    "tips": [
      "استخدم دائمًا الماء المعدني للشطف النهائي بعد البلسم",
      "ضع زيت Seven Minerals باعتدال - 2-3 قطرات كافية",
      "استخدم Cantu Leave-In يوميًا للترطيب والحماية",
      "زيت Elvive مثالي للتصفيف ولمعان الشعر الجاف"
    ],
    "table": {
      "day": "اليوم",
      "steps": "الخطوات"
    },
    "routine": [
      {"day": "السبت", "steps": "شامبو + بلسم، ثم زيت Seven Minerals على فروة الرأس + كريم Cantu على الشعر"},
      {"day": "الثلاثاء", "steps": "بلسم فقط + شطف بالماء المعدني، ويمكن استخدام Elvive أو Cantu حسب الحاجة"},
      {"day": "الخميس", "steps": "شامبو + بلسم، ثم Seven Minerals على فروة الرأس + Cantu على الأطراف"},
      {"day": "أيام أخرى", "steps": "استخدم Cantu أو Elvive حسب الحاجة، بدون غسل"}
    ],
    "productTable": {
      "product": "المنتج",
      "instructions": "التعليمات"
    },
    "productsList": [
      {"product": "شامبو لوريال إيفر بيور", "instructions": "يستخدم مرتين في الأسبوع على فروة الرأس والشعر، ثم يشطف"},
      {"product": "بلسم لوريال إيفر بيور", "instructions": "يوضع بعد الشامبو، يترك 2-3 دقائق، يشطف بالماء العادي ثم شطف نهائي بالماء المعدني"},
      {"product": "Cantu Leave-In", "instructions": "يستخدم يوميًا بعد الشطف بالماء المعدني أو الاستحمام، كمية قليلة على الشعر الرطب أو الجاف"},
      {"product": "زيت Seven Minerals", "instructions": "2-3 قطرات على فروة الرأس مرتين في الأسبوع، تدليك بلطف. اختياري: قطرة واحدة على الأطراف للمعان"},
      {"product": "زيت Elvive", "instructions": "يستخدم قبل الخروج أو لتصفيف خفيف على أطراف الشعر الجاف"}
    ]
  },
  "skinRoutine": {
    "title": "روتين البشرة",
    "subtitle": "روتين العناية بالبشرة ودليل المنتجات",
    "comingSoon": "قريبًا!",
    "comingSoonDesc": "سيتم إضافة محتوى روتين البشرة هنا لاحقًا",
    "underDevelopment": "🚧 تحت التطوير",
    "dailyRoutine": "الروتين اليومي",
    "dailyRoutineDesc": "خطوات العناية الصباحية والمسائية",
    "productGuide": "دليل المنتجات",
    "productGuideDesc": "منتجات العناية بالبشرة وتعليمات الاستخدام",
    "placeholder": "سيتم إضافة المحتوى هنا..."
  },
  "nutritionPlan": {
    "title": "الأسبوع 1 – خطة استعادة التمثيل الغذائي",
    "subtitle": "خطة تغذية مدتها 7 أيام لإعادة توازن التمثيل الغذائي ومستويات الطاقة",
    "overview": "نظرة عامة",
    "overviewText": "تساعد خطة استعادة التمثيل الغذائي هذه لمدة 7 أيام على إعادة ضبط عملية التمثيل الغذائي للجسم واستقرار مستويات الطاقة بعد فترة من عادات الأكل غير المتسقة. تركز على وجبات بسيطة ومتوازنة بمكونات طبيعية، حصص معتدلة، بدون أطعمة سريعة أو مكسرات.",
    "dailyCalorieRange": "نطاق السعرات الحرارية اليومية",
    "dailyCalorieDesc": "سعرات حرارية للصيانة لاستعادة التمثيل الغذائي",
    "total": "المجموع",
    "maintenance": "صيانة للأسبوع الأول",
    "macros": "المغذيات الكبيرة",
    "protein": "البروتين",
    "carbs": "الكربوهيدرات",
    "fats": "الدهون",
    "keyRules": "القواعد الأساسية",
    "keyRulesDesc": "إرشادات ضرورية لهذه الخطة",
    "rule1": "تناول",
    "rule1Meals": "2–3 وجبات رئيسية صغيرة",
    "rule1And": "و",
    "rule1Snack": "وجبة خفيفة واحدة",
    "rule1Daily": "يوميًا.",
    "rule2": "اشرب",
    "rule2Water": "2.5–3 لتر من الماء",
    "rule2PerDay": "في اليوم.",
    "rule3": "تجنب تخطي الوجبات، حتى لو لم تكن جائعًا.",
    "rule4": "بدون مكسرات، رقائق، بذور منكهة، حليب بالشوكولاتة، أو مشروبات غازية.",
    "rule5": "قلل من العصائر إلى",
    "rule5Times": "1–2 مرات في الأسبوع",
    "rule5End": ".",
    "rule6": "القهوة والشاي بدون سكر مسموح بهما (ستيفيا اختياري).",
    "breakfastOptions": "خيارات الإفطار",
    "breakfastDesc": "اختر واحدًا يوميًا",
    "option": "الخيار",
    "tip": "نصيحة",
    "breakfastOption1": "ساندويتش جبنة بيضاء + قهوة/شاي + فاكهة واحدة (موز أو تفاح)",
    "breakfastOption2": "2 بيضة مسلوقة + خبز قمح كامل + خيار وطماطم",
    "breakfastOption3": "شوفان مع حليب قليل الدسم + 1 ملعقة صغيرة عسل (اختياري)",
    "breakfastTip": "إذا لم تكن جائعًا في الصباح، تناول على الأقل فاكهة + قهوة لتحفيز التمثيل الغذائي.",
    "lunchOptions": "خيارات الغداء",
    "protein": "البروتين",
    "proteinDesc": "200 جرام اختر واحد",
    "protein1": "صدر دجاج مشوي",
    "protein2": "لحم مفروم مشوي (كفتة)",
    "protein3": "سمك مشوي أو مخبوز / تونة (مصفاة)",
    "carbs": "الكربوهيدرات",
    "carbsDesc": "اختر واحد",
    "carbs1": "½ كوب أرز مطبوخ",
    "carbs2": "رغيف قمح كامل صغير",
    "carbs3": "1 بطاطس متوسطة مسلوقة أو مخبوزة",
    "vegetables": "الخضروات",
    "vegetablesDesc": "إلزامي",
    "vegetables1": "سلطة كبيرة مع صلصة زيت الزيتون",
    "vegetables2": "أو خضروات مطبوخة على البخار (جزر، كوسة، فلفل)",
    "optional": "اختياري",
    "optionalDesc": "1–2 مرات/أسبوع",
    "optional1": "1 كوب من العصير الطبيعي أو الحليب العادي (بدون شوكولاتة)",
    "dinnerOptions": "خيارات العشاء",
    "dinnerSubtitle": "خفيف",
    "dinner1": "زبادي قليل الدسم + 2 تمرة",
    "dinner2": "1 بيضة مسلوقة + خيار",
    "dinner3": "1 كوب حليب + 1 خبز محمص صغير مع جبنة خفيفة",
    "dinnerTip": "تخطى العشاء فقط إذا لم تكن جائعًا على الإطلاق؛ وإلا اختر خيارًا خفيفًا.",
    "snackOptions": "خيارات الوجبات الخفيفة",
    "snackDesc": "مرة واحدة في اليوم فقط",
    "snack1": "1 فاكهة (تفاح، برتقال، موز)",
    "snack2": "أو 3 تمرات صغيرة",
    "snack3": "أو 1 بسكويت شوفان صحي",
    "hydration": "الترطيب",
    "hydrationText": "اشرب",
    "hydrationWater": "2.5–3 لتر من الماء",
    "hydrationDaily": "يوميًا.",
    "hydrationTip": "كوب واحد قبل كل وجبة موصى به.",
    "weekSchedule": "جدول الأسبوع مثال",
    "weekScheduleDesc": "تفصيل الوجبات اليومية للأسبوع",
    "planBadge": "خطة 7 أيام",
    "table": {
      "day": "اليوم",
      "breakfast": "الإفطار",
      "lunch": "الغداء",
      "dinner": "العشاء",
      "snack": "وجبة خفيفة"
    },
    "schedule": [
      {"day": "الاثنين", "breakfast": "الخيار 1", "lunch": "دجاج + أرز + سلطة", "dinner": "زبادي + 2 تمرة", "snack": "تفاح"},
      {"day": "الثلاثاء", "breakfast": "الخيار 2", "lunch": "كفتة + خبز + خضروات", "dinner": "بيضة مسلوقة + خيار", "snack": "3 تمرات"},
      {"day": "الأربعاء", "breakfast": "الخيار 3", "lunch": "سمك + بطاطس + سلطة", "dinner": "حليب + خبز محمص + جبنة", "snack": "برتقال"},
      {"day": "الخميس", "breakfast": "الخيار 1", "lunch": "دجاج + أرز + سلطة", "dinner": "زبادي + 2 تمرة", "snack": "بسكويت شوفان"},
      {"day": "الجمعة", "breakfast": "الخيار 2", "lunch": "كفتة + خبز + سلطة", "dinner": "بيضة مسلوقة + خيار", "snack": "موز"},
      {"day": "السبت", "breakfast": "الخيار 3", "lunch": "سمك + بطاطس + سلطة", "dinner": "حليب + خبز محمص + جبنة", "snack": "تفاح"},
      {"day": "الأحد", "breakfast": "الخيار 1", "lunch": "دجاج + أرز + سلطة", "dinner": "زبادي + 2 تمرة", "snack": "برتقال"}
    ],
    "notes": "ملاحظات",
    "note1": "الهدف: استعادة التمثيل الغذائي الطبيعي قبل بدء عجز السعرات الحرارية.",
    "note2": "ركز على الانتظام والترطيب، وليس فقدان الوزن السريع.",
    "note3": "ابدأ تدريب الجيم بتمارين خفيفة للجسم كامل",
    "note3Times": "3–4 مرات في الأسبوع",
    "note3End": ".",
    "note4": "زن نفسك مرتين فقط: في بداية ونهاية الأسبوع.",
    "note5": "بعد هذه المرحلة، يمكن أن تبدأ خطة فقدان الدهون التدريجي بأمان.",
    "phase2": "المرحلة 2 (الخطوات التالية)",
    "phase2Desc": "ما يأتي بعد خطة استعادة التمثيل الغذائي للأسبوع 1",
    "phase2Intro": "بعد إكمال خطة استعادة التمثيل الغذائي للأسبوع 1:",
    "phase2Step1": "قيم كيف يشعر جسمك — تحقق من الطاقة والنوم والشهية.",
    "phase2Step2": "إذا كانت الطاقة مستقرة والهضم طبيعي، انتقل إلى",
    "phase2Step2Bold": "المرحلة 2: فقدان الدهون التدريجي",
    "phase2Step2End": ".",
    "phase2Step3": "في المرحلة 2، ستنخفض إجمالي السعرات الحرارية بمقدار",
    "phase2Step3Bold": "300–400 سعرة حرارية يوميًا",
    "phase2Step3End": "، مع الحفاظ على وجبات متوازنة.",
    "phase2Step4": "شمل",
    "phase2Step4Bold1": "4 أيام من تدريب المقاومة",
    "phase2Step4And": "و",
    "phase2Step4Bold2": "1–2 جلسة كارديو خفيفة",
    "phase2Step4End": "أسبوعيًا.",
    "phase2Step5": "أضف يوم",
    "phase2Step5Bold": "\"إعادة تغذية\"",
    "phase2Step5End": "واحد كل 7–10 أيام للحفاظ على صحة التمثيل الغذائي.",
    "phase2Step6": "ركز على الاستدامة، وليس الكمال —",
    "phase2Step6Bold": "الانتظام هو الأهم",
    "phase2Step6End": "."
  },
  "phoenixTracker": {
    "title": "متتبع فينيكس",
    "subtitle": "تتبع رحلة تحول جسمك",
    "units": {
      "metric": "متري",
      "imperial": "إمبراطوري",
      "kg": "كجم",
      "lb": "رطل",
      "cm": "سم",
      "in": "بوصة",
      "switchTo": "التبديل إلى {{system}}"
    },
    "tabs": {
      "today": "الرئيسية",
      "weight": "الوزن",
      "water": "الماء",
      "meals": "الوجبات",
      "measurements": "القياسات",
      "workouts": "التمارين",
      "photos": "الصور",
      "news": "الأخبار",
      "social": "السوشيال",
      "progress": "التقدم",
      "profile": "حسابى"
    },
    "today": {
      "greetingNamed": "أهلاً {{name}} 👋",
      "greetingPlain": "أهلاً 👋",
      "weight": "الوزن",
      "meals": "الوجبات",
      "workout": "التمرين",
      "moodTitle": "حاسس بإيه النهارده؟",
      "energyTitle": "وطاقتك عاملة إيه؟",
      "mood": "المزاج",
      "energy": "الطاقة",
      "moodWord1": "زفت",
      "moodWord2": "مش ولا بد",
      "moodWord3": "ماشي",
      "moodWord4": "كويس",
      "moodWord5": "ممتاز",
      "energyWord1": "فاضية",
      "energyWord2": "واطية",
      "energyWord3": "نص نص",
      "energyWord4": "عالية",
      "energyWord5": "فل",
      "couplesTitle": "إنت و{{name}}",
      "dailyQuestion": "سؤال اليوم",
      "qState": {
        "neither": "اختار سؤال النهارده",
        "iAnsweredWaiting": "خلّصت — مستني {{name}}",
        "partnerAnsweredYourTurn": "{{name}} جاوب — دورك",
        "bothDone": "خلّصتوا — شوف الإجابات"
      },
      "wordle": "وردل",
      "wordleState": {
        "neither": "كلمة النهارده مستنياكم",
        "iPlaying": "إنت في النص",
        "iPlayingPartnerDone": "إنت في النص · {{name}} خلّص",
        "bothPlaying": "الاتنين بتلعبوا",
        "partnerPlaying": "{{name}} بدأ — دورك",
        "partnerDoneYourTurn": "{{name}} خلّص — دورك",
        "iDoneWaiting": "إنت خلّصت — مستني {{name}}",
        "iDonePartnerPlaying": "إنت خلّصت · {{name}} لسه بيلعب",
        "bothFinished": "خلّصتوا — شيّروا النتيجة"
      },
      "quiz": "كويز",
      "quizState": {
        "fresh": "ابدأ جولة جديدة",
        "myTurn": "في جولة مستنياك",
        "waiting": "مستني {{name}}",
        "revealReady": "النتيجة جاهزة"
      },
      "moments": "لقطاتنا",
      "momentsState": {
        "noPromptYet": "مستنيين إشعار النهارده",
        "openNeither": "الكاميرا فاتحة — صوّر دلوقتي",
        "iSubmittedWaiting": "بعتها — مستني {{name}}",
        "partnerSubmittedYourTurn": "{{name}} بعت — دورك",
        "bothRevealed": "الاتنين بعتوا — افتح الكشف",
        "bothMissed": "ضيّعتوها سوا",
        "partnerMissedMine": "{{name}} ضيّعها",
        "iMissedPartner": "ضيّعتها"
      },
      "currentWeight": "وزنك الحالي",
      "headline": "أهم خبر",
      "more": "كمان"
    },
    "weight": {
      "date": "التاريخ",
      "weight": "الوزن (كجم)",
      "add": "إضافة",
      "save": "حفظ",
      "cancel": "إلغاء",
      "edit": "تعديل",
      "delete": "حذف",
      "confirmDelete": "حذف هذا الإدخال؟",
      "confirmDeleteDesc": "سيؤدي هذا إلى حذف إدخال الوزن نهائيًا.",
      "noEntries": "لا توجد إدخالات وزن بعد. ابدأ التتبع!",
      "showMore": "عرض المزيد",
      "showLess": "عرض أقل",
      "trend": "اتجاه الوزن",
      "kg": "كجم",
      "gained": "زيادة",
      "lost": "نقصان",
      "note": "ملاحظة",
      "notePlaceholder": "أضف ملاحظة (اختياري)",
      "movingAverage": "المتوسط المتحرك",
      "windows": {
        "day": "ي",
        "off": "إيقاف"
      },
      "legendDailyLabel": "الوزن اليومي",
      "legendDailyDesc": "قراءة الميزان الفعلية لكل يوم",
      "legendAvgLabel": "متوسط {{window}} أيام",
      "legendAvgDesc": "اتجاه ممهّد — بيتأخر عن القيمة الحالية لو الوزن بيتغير بسرعة",
      "dateToday": "اليوم",
      "dateYesterday": "أمس",
      "addNote": "إضافة ملاحظة",
      "logWeight": "تسجيل الوزن",
      "weightPlaceholder": "0.0",
      "tapToEnter": "اضغط لإدخال وزنك",
      "trendOverDays": "{{delta}} {{unit}} خلال {{n}} يوم"
    },
    "measurements": {
      "date": "التاريخ",
      "neck": "الرقبة",
      "chest": "الصدر",
      "belly": "البطن",
      "waist": "الخصر",
      "arm": "الذراع",
      "thigh": "الفخذ",
      "add": "إضافة قياس",
      "delete": "حذف",
      "confirmDelete": "حذف هذا القياس؟",
      "confirmDeleteDesc": "سيؤدي هذا إلى حذف مجموعة القياسات نهائيًا.",
      "noEntries": "لا توجد قياسات بعد. ابدأ التتبع!",
      "cm": "سم",
      "note": "ملاحظة",
      "notePlaceholder": "أضف ملاحظة (اختياري)",
      "trend": "اتجاه القياس",
      "selectMetric": "اختر القياس",
      "bodyFat": "نسبة الدهون"
    },
    "progress": {
      "title": "لوحة التقدم",
      "startWeight": "وزن البداية",
      "goalWeight": "الوزن المستهدف",
      "currentWeight": "الوزن الحالي",
      "totalLost": "إجمالي الفقد",
      "remaining": "المتبقي",
      "avgLossRate": "متوسط الفقد (7 أيام)",
      "lowestWeight": "أقل وزن",
      "highestWeight": "أعلى وزن",
      "totalEntries": "إجمالي الإدخالات",
      "currentStreak": "السلسلة الحالية",
      "longestStreak": "أطول سلسلة",
      "days": "أيام",
      "bmi": "مؤشر كتلة الجسم",
      "bodyFat": "نسبة الدهون",
      "category": {
        "underweight": "نقص في الوزن",
        "normal": "طبيعي",
        "overweight": "زيادة في الوزن",
        "obese": "سمنة"
      },
      "pace": {
        "ahead": "متقدم على المسار بـ {{delta}} {{unit}}/أسبوع",
        "on": "على المسار 🎯",
        "behind": "متأخر عن المسار بـ {{delta}} {{unit}}/أسبوع"
      },
      "incompleteGoals": "حدد أهدافك لرؤية إحصائيات التقدم",
      "completeGoalsCta": "تحديد الأهداف",
      "setHeight": "أدخل طولك",
      "setHeightDesc": "أدخل طولك لتفعيل تتبع مؤشر كتلة الجسم",
      "height": "الطول",
      "cm": "سم",
      "saveHeight": "حفظ الطول",
      "activity": "النشاط",
      "daysLogged": "{{count}} من {{total}} يوم مسجل",
      "noEntry": "لا يوجد إدخال",
      "milestones": {
        "title": "المعالم",
        "reached": "تم الوصول في {{date}}",
        "toGo": "{{value}} {{unit}} متبقي",
        "goal": "الهدف",
        "allReached": "تم الوصول لجميع المعالم!"
      },
      "weekShort": "أسبوع",
      "progressBar": "التقدم",
      "noData": "أضف إدخالات الوزن لرؤية تقدمك",
      "completed": "مكتمل",
      "perWeek": "كجم/أسبوع",
      "summary": {
        "week": { "title": "هذا الأسبوع" },
        "month": { "title": "هذا الشهر" },
        "weightLost": "نزلت {{delta}} {{unit}}",
        "weightGained": "زدت {{delta}} {{unit}}",
        "weightNoChange": "مفيش تغيير في الوزن",
        "bestDay": "أفضل يوم: {{day}} — نزلت {{delta}} {{unit}}",
        "water": "متوسط الماء {{avg}} لتر/يوم · حققت الهدف {{hit}}/{{of}} أيام",
        "workouts": "{{count}} جلسة · {{volume}} كجم حجم",
        "workoutsWithCardio": "{{count}} جلسة · {{volume}} كجم حجم · {{cardio}} دقيقة كارديو",
        "mealsAvg": "متوسط {{avgKcal}} سعرة/يوم · {{entries}} وجبة"
      }
    },
    "meals": {
      "title": "الوجبات",
      "subtitle": "تتبع السعرات والماكروز.",
      "today": "اليوم",
      "addCta": "إضافة وجبة",
      "addForType": "+ إضافة {{type}}",
      "empty": "مفيش وجبات مسجلة لليوم ده لسه.",
      "kcalUnit": "سعرة",
      "dailyTotal": "إجمالي اليوم",
      "search": {
        "label": "ابحث في قاعدة بيانات الأطعمة",
        "placeholder": "ابحث في Open Food Facts (شوفان، فراخ…)",
        "noResults": "لا توجد نتائج. جرب كلمة تانية أو املأ الحقول يدويًا.",
        "attribution": "لكل 100جم · بدعم من Open Food Facts (CC-BY-SA)"
      },
      "types": {
        "breakfast": "فطار",
        "lunch": "غدا",
        "dinner": "عشا",
        "snack": "سناك"
      },
      "macrosShort": "{{protein}}ب / {{carbs}}ك / {{fat}}د",
      "treatBadge": "كل فترة",
      "form": {
        "title": "تسجيل وجبة",
        "editTitle": "تعديل الوجبة",
        "type": "نوع الوجبة",
        "name": "الاسم",
        "namePlaceholder": "شوفان، طبق فراخ…",
        "portion": "الحصة (جم)",
        "myFoods": "أكلاتي",
        "recent": "الأخيرة",
        "kcal": "السعرات",
        "macrosToggle": "الماكروز (اختياري)",
        "protein": "بروتين (جم)",
        "carbs": "كارب (جم)",
        "fat": "دهون (جم)",
        "notes": "ملاحظات",
        "notesPlaceholder": "أي حاجة تستاهل تتفكر…",
        "save": "حفظ الوجبة",
        "saving": "جاري الحفظ…",
        "cancel": "إلغاء",
        "errorName": "الاسم مطلوب.",
        "errorKcal": "السعرات لازم تكون صفر أو أكتر."
      },
      "confirmDelete": "حذف هذه الوجبة؟",
      "confirmDeleteDesc": "هتتحذف الوجبة دي من سجلك.",
      "delete": "حذف الوجبة",
      "targets": {
        "title": "تقدم اليوم",
        "edit": "تعديل الأهداف",
        "set": "تعيين الأهداف",
        "noTargets": "حدد أهداف السعرات والماكروز اليومية عشان تظهر حلقات التقدم هنا.",
        "suggestedTitle": "طبّق أهدافك اليومية من خطتك",
        "suggestedApply": "تطبيق",
        "form": {
          "kcal": "السعرات اليومية",
          "protein": "بروتين (جم)",
          "carbs": "كارب (جم)",
          "fat": "دهون (جم)",
          "save": "حفظ الأهداف",
          "clear": "مسح كل الأهداف"
        }
      },
      "rings": {
        "kcal": "السعرات",
        "protein": "بروتين",
        "carbs": "كارب",
        "fat": "دهون"
      },
      "builder": {
        "heading": "اختار اللي اكلته",
        "suggestedHeading": "مقترحات لـ{{slot}}",
        "otherFoodsHeading": "أكلات أخرى",
        "noFoods": "مفيش أكلات لسه. ضيف طعام مخصص.",
        "searchPlaceholder": "بحث عن طعام…",
        "clearSearch": "مسح البحث",
        "noSearchResults": "مفيش أكلات تطابق \"{{query}}\".",
        "recipeIngredients": "المكونات",
        "addCustom": "إضافة طعام مخصص",
        "totalLabel": "الإجمالي",
        "itemsCount_zero": "{{count}} عنصر",
        "itemsCount_one": "عنصر واحد",
        "itemsCount_two": "عنصران",
        "itemsCount_few": "{{count}} عناصر",
        "itemsCount_many": "{{count}} عنصرًا",
        "itemsCount_other": "{{count}} عنصر"
      },
      "slot": {
        "tapToLog": "اضغط لتسجيل {{slot}}",
        "addAnother": "إضافة المزيد"
      }
    },
    "analysis": {
      "sectionTitle": "التحليل",
      "rangeAria": "نطاق التحليل",
      "range": {
        "phase": "المرحلة"
      },
      "insights": {
        "title": "ملاحظات",
        "empty": "البيانات لسه قليلة — سجّل كام يوم تاني تشوف الملاحظات.",
        "weeklyChangeLosing": "بتخسر <0>{{rate}} كجم/أسبوع</0> تقريبًا خلال الفترة دي.",
        "weeklyChangeGaining": "بتكسب <0>{{rate}} كجم/أسبوع</0> تقريبًا خلال الفترة دي.",
        "kcalAvg": "متوسط استهلاك يومي <0>{{avg}} سعرة</0> — {{delta}} مقارنة بهدف <0>{{target}}</0>.",
        "trainingRestKcal": "أيام التمرين أعلى بـ<0>{{delta}} سعرة</0> عن أيام الراحة.",
        "kcalBurnedAvg": "بتحرق <0>{{burn}} سعرة</0> تقريبًا في يوم التمرين.",
        "mealStreak": "أطول سلسلة تسجيل وجبات: <0>{{streak}} يوم</0>.",
        "lowProtein": "حققت هدف البروتين في <0>{{pct}}%</0> من الأيام — محتاج تركيز.",
        "highProtein": "حققت هدف البروتين في <0>{{pct}}%</0> من الأيام — التزام قوي."
      },
      "weightCalories": {
        "title": "الوزن × السعرات",
        "weight": "الوزن",
        "kcal": "سعرات داخلة",
        "kcalBurned": "سعرات محروقة",
        "empty": "مفيش بيانات وزن أو وجبات في الفترة دي."
      },
      "adherence": {
        "title": "الالتزام بالماكروز",
        "subtitle": "الأيام اللي حققت فيها الهدف ±١٠٪ — من {{days}} من {{total}} يوم مسجّل.",
        "noTargets": "حدد أهدافك اليومية في تبويب الوجبات عشان تشوف الالتزام هنا.",
        "kcal": "السعرات",
        "protein": "بروتين",
        "carbs": "كارب",
        "fat": "دهون"
      },
      "matrix": {
        "title": "أيام التمرين × أيام الراحة",
        "training": "تمرين",
        "rest": "راحة",
        "daysShort": "يوم",
        "empty": "سجّل تمارين ووجبات عشان نقدر نقارن أيام التمرين والراحة.",
        "kcal": "متوسط السعرات",
        "protein": "متوسط البروتين (جم)",
        "carbs": "متوسط الكارب (جم)",
        "fat": "متوسط الدهون (جم)",
        "kcalBurned": "متوسط السعرات المحروقة"
      },
      "streaks": {
        "title": "سلاسل التسجيل",
        "weight": "الوزن",
        "meals": "الوجبات",
        "water": "الماء",
        "best": "أفضل {{n}}"
      }
    },
    "phases": {
      "title": "المراحل",
      "subtitle": "تتبع مراحل تحوّلك.",
      "manageLink": "إدارة المراحل",
      "currentTitle": "المرحلة الحالية",
      "noCurrent": "لا توجد مرحلة نشطة",
      "addCta": "مرحلة جديدة",
      "empty": "مفيش مراحل لسه. حدّد مرحلتك الأولى لتتبع جزء مركّز من تحوّلك.",
      "type": {
        "cut": "تقطيع",
        "maintain": "ثبات",
        "bulk": "زيادة"
      },
      "form": {
        "name": "الاسم (اختياري)",
        "namePlaceholder": "تقطيع الربيع، زيادة صغيرة، إلخ.",
        "phaseType": "نوع المرحلة",
        "startDate": "تاريخ البداية",
        "endDate": "تاريخ النهاية (اختياري)",
        "startWeight": "وزن البداية",
        "startWeightHint": "تم تعبئته من آخر قياس وزن",
        "goalWeight": "الوزن المستهدف",
        "goalWeightHintCutBulk": "مطلوب لمراحل التقطيع والزيادة",
        "goalWeightHintMaintain": "اختياري لمرحلة الثبات",
        "notes": "ملاحظات",
        "notesPlaceholder": "ليه المرحلة دي؟ نظام غذائي، تعديل تدريب، ديدلاين…",
        "save": "حفظ المرحلة",
        "saving": "جاري الحفظ…",
        "edit": "تعديل",
        "cancel": "إلغاء",
        "errorMissingStartWeight": "وزن البداية مطلوب.",
        "errorMissingGoalForCutBulk": "الوزن المستهدف مطلوب لمراحل التقطيع والزيادة.",
        "errorEndBeforeStart": "تاريخ النهاية ما يقدرش يبقى قبل تاريخ البداية."
      },
      "stats": {
        "daysInto": "اليوم {{n}}",
        "delta": "{{delta}} {{unit}}",
        "deltaLost": "نزلت {{delta}} {{unit}}",
        "deltaGained": "زدت {{delta}} {{unit}}",
        "deltaNoChange": "بدون تغيير",
        "progress": "{{percent}}% من هدف المرحلة",
        "noPhaseGoal": "بدون هدف",
        "currentWeight": "الحالي",
        "phaseGoal": "الهدف",
        "phaseStart": "البداية"
      },
      "list": {
        "active": "نشطة",
        "ended": "انتهت في {{date}}",
        "ongoing": "مستمرة"
      },
      "confirmDelete": "حذف هذه المرحلة؟",
      "confirmDeleteDesc": "هتتحذف المرحلة، لكن إدخالات الوزن داخلها هتفضل موجودة.",
      "delete": "حذف المرحلة",
      "autoClosedPrev": "تم إغلاق المرحلة السابقة في {{date}}",
      "pacePhase": {
        "ahead": "متقدم على وتيرة المرحلة بـ {{delta}} {{unit}}/أسبوع",
        "on": "على وتيرة المرحلة 🎯",
        "behind": "متأخر عن وتيرة المرحلة بـ {{delta}} {{unit}}/أسبوع"
      }
    },
    "onboarding": {
      "welcome": {
        "title": "مرحبًا بك في Phoenix Tracker",
        "subtitle": "لنُعِدّ أهدافك.",
        "cta": "ابدأ"
      },
      "name": {
        "title": "ما اسمك؟",
        "subtitle": "سنستخدمه للترحيب بك.",
        "placeholder": "اسمك"
      },
      "birthday": {
        "title": "ما تاريخ ميلادك؟",
        "subtitle": "سنحتفل معك (ونحسب العمر)."
      },
      "sex": {
        "title": "الجنس",
        "subtitle": "اختياري — يستخدم للحسابات المستقبلية.",
        "male": "ذكر",
        "female": "أنثى",
        "preferNot": "أفضّل عدم الإفصاح"
      },
      "units": {
        "title": "وحدات القياس المفضلة",
        "subtitle": "يمكنك تغييرها لاحقًا.",
        "metric": "متري (كجم / سم)",
        "imperial": "إمبراطوري (رطل / بوصة)"
      },
      "startWeight": {
        "title": "ما وزنك الحالي؟",
        "subtitle": "سنتتبع تقدمك من هذا الرقم.",
        "dateLabel": "تاريخ البداية"
      },
      "goalWeight": {
        "title": "ما وزنك المستهدف؟",
        "preview": "إجمالي الوزن المراد فقده: {{amount}} {{unit}}",
        "warningSameOrHigher": "الوزن المستهدف يجب أن يكون أقل من الوزن الحالي."
      },
      "goalDate": {
        "title": "متى تريد الوصول إليه؟",
        "subtitle": "اختياري — يساعدنا في عرض رؤى الإيقاع.",
        "preview": "{{weeks}} أسابيع → {{rate}} {{unit}}/أسبوع"
      },
      "height": {
        "title": "ما طولك؟",
        "subtitle": "يستخدم لحساب مؤشر كتلة الجسم."
      },
      "waterGoal": {
        "title": "هدف الماء اليومي؟",
        "subtitle": "سنعرض تقدمك خلال اليوم.",
        "preset2L": "2 لتر",
        "preset25": "2.5 لتر",
        "preset3": "3 لتر"
      },
      "done": {
        "title": "كل شيء جاهز!",
        "summaryHeader": "هذه خطتك:",
        "cta": "ابدأ التتبع"
      },
      "nav": {
        "back": "رجوع",
        "next": "التالي",
        "skip": "تخطي",
        "edit": "تعديل الأهداف",
        "saveChanges": "حفظ التغييرات"
      },
      "progress": {
        "stepOf": "خطوة {{current}} من {{total}}"
      }
    },
    "auth": {
      "signIn": "تسجيل الدخول",
      "signUp": "إنشاء حساب",
      "signOut": "تسجيل الخروج",
      "confirmSignOut": "هل تريد تسجيل الخروج؟",
      "confirmSignOutDesc": "ستحتاج إلى تسجيل الدخول مرة أخرى للوصول إلى بياناتك.",
      "email": "البريد الإلكتروني",
      "password": "كلمة المرور",
      "noAccount": "ليس لديك حساب؟",
      "hasAccount": "لديك حساب بالفعل؟",
      "signUpDisabled": "التسجيل محدود حاليًا. إذا كنت بحاجة إلى الوصول، يرجى التواصل مع المطور.",
      "signUpOpenWindow": "التسجيل مفتوح خلال الـ {{remaining}} القادمة.",
      "signUpCloses": "يُغلق في {{when}}.",
      "builtBy": "تم التطوير بواسطة",
      "checkEmail": "تحقق من بريدك الإلكتروني",
      "confirmEmail": "أرسلنا لك رابط تأكيد. يرجى التحقق من بريدك الإلكتروني لتفعيل حسابك."
    },
    "photos": {
      "title": "صور التقدم",
      "uploadTitle": "إضافة صورة",
      "date": "التاريخ",
      "pose": "الوضعية",
      "front": "أمامي",
      "side": "جانبي",
      "back": "خلفي",
      "selectFile": "اضغط لاختيار صورة",
      "caption": "تعليق (اختياري)",
      "captionPlaceholder": "أضف تعليقًا...",
      "upload": "رفع",
      "uploading": "جاري الرفع...",
      "delete": "حذف",
      "confirmDelete": "حذف هذه الصورة؟",
      "confirmDeleteDesc": "سيتم حذف ملف الصورة وسجلها في قاعدة البيانات.",
      "noPhotos": "لا توجد صور بعد. ارفع صورة التقدم الأولى!",
      "compressing": "جاري معالجة الصورة...",
      "tapToReveal": "اضغط للكشف",
      "revealAll": "إظهار الكل",
      "hideAll": "إخفاء الكل",
      "hide": "إخفاء",
      "storage": {
        "title": "أين نحفظ هذه الصورة؟",
        "cloud": "السحابة",
        "cloudDesc": "مزامنة بين الأجهزة",
        "cloudLong": "تُحفظ في حسابك على Supabase. مشفرة أثناء التخزين. يمكن الوصول إليها من أي جهاز مسجَّل دخوله. ليست مشفرة من طرف إلى طرف.",
        "local": "هذا الجهاز فقط",
        "localDesc": "لا تغادر هاتفك",
        "localLong": "تُحفظ فقط في تخزين المتصفح على هذا الجهاز. ستُفقد إذا قمت بإلغاء تثبيت التطبيق، أو مسح بيانات الموقع، أو (على iOS) لم تفتح التطبيق لمدة ~7 أيام. لا تتم مزامنتها مع الأجهزة الأخرى.",
        "localBadge": "محفوظة على هذا الجهاز",
        "pendingBadge": "في انتظار الرفع — هتتزامن لما ترجع أونلاين"
      },
      "compare": "مقارنة",
      "comparePhotos": "مقارنة الصور",
      "selectFirst": "اختر الصورة الأولى (قبل)",
      "selectSecond": "اختر الصورة الثانية (بعد)",
      "vs": "مقابل",
      "all": "الكل",
      "daysApart": "{{days}} يوم بينهما",
      "sameDay": "نفس اليوم",
      "needMorePhotos": "تحتاج إلى صورتين على الأقل للمقارنة"
    },
    "water": {
      "title": "شرب الماء",
      "today": "اليوم",
      "ml": "مل",
      "l": "لتر",
      "glass": "كوب",
      "glasses": "أكواب",
      "addGlass": "+ كوب",
      "addCustom": "إضافة",
      "customPlaceholder": "كمية مخصصة (مل)",
      "goal": "الهدف اليومي",
      "goalMet": "تم تحقيق الهدف!",
      "noEntries": "لا توجد إدخالات ماء بعد. حافظ على الترطيب!",
      "history": "السجل",
      "edit": "تعديل",
      "delete": "حذف",
      "confirmDelete": "حذف هذا الإدخال؟",
      "confirmDeleteDesc": "سيؤدي هذا إلى حذف إدخال الماء نهائيًا.",
      "addPastDay": "نسيت التسجيل؟ أضف ليوم آخر",
      "pastDayAmount": "الكمية (مل)",
      "pastDayAdd": "إضافة",
      "stats": {
        "avg7Day": "متوسط 7 أيام",
        "avg30Day": "متوسط 30 يوم",
        "hitRate": "نسبة تحقيق الهدف",
        "bestDay": "أفضل يوم",
        "currentStreak": "السلسلة"
      }
    },
    "export": {
      "exportData": "تصدير البيانات بصيغة CSV"
    },
    "loading": "جاري التحميل...",
    "error": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
    "retry": "إعادة المحاولة",
    "saving": "جاري الحفظ..."
  },
  "pwa": {
    "install": {
      "title": "ثبّت تطبيق Routine",
      "body": "أضفه إلى شاشتك الرئيسية لتجربة أسرع وبملء الشاشة.",
      "button": "تثبيت",
      "dismiss": "ليس الآن",
      "iosTitle": "التثبيت على iPhone",
      "iosStep1": "اضغط على أيقونة المشاركة",
      "iosStep2": "ثم اختر",
      "iosAddToHome": "إضافة إلى الشاشة الرئيسية"
    },
    "update": {
      "title": "إصدار جديد متاح",
      "subtitle": "اضغط تحديث عشان تستلم آخر التحسينات",
      "button": "تحديث",
      "updating": "جاري التحديث…",
      "dismiss": "إخفاء"
    }
  },
  "offline": {
    "banner": "أنت غير متصل بالإنترنت",
    "subtitle": "عرض البيانات المحفوظة — لن تتم مزامنة التغييرات حتى تعود إلى الإنترنت."
  },
  "sync": {
    "pending": "جاري المزامنة…",
    "pendingOffline": "ستتم المزامنة عند الاتصال",
    "pendingCount": "{{count}} تغيير في انتظار المزامنة",
    "stuck": "خطأ في المزامنة — اضغط لإعادة المحاولة",
    "retry": "إعادة المحاولة"
  }
};